import React, {useState, useEffect, useRef} from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import countryOptions from "../components/List/Countries";
import UploadedFilePreview from "components/MDDropzone/UploadedFilePreview";
import {Alert, Chip, CircularProgress, FormControlLabel, Snackbar, Tooltip} from "@mui/material";
// Büyük sayfada her tuşta tüm sayfanın yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";
import DecimalTextField from "components/DecimalTextField";
import MenuItem from "@mui/material/MenuItem";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { getISOWeek } from "date-fns";
import MDDropzone from "../../../../../components/MDDropzone";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import { GlobalWorkerOptions } from "pdfjs-dist";
import {useLocation, useNavigate} from "react-router-dom";
import DashboardLayout from "../../../../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../../../examples/Navbars/DashboardNavbar";
import CrudService from "services/cruds-service";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import * as mongoose from "three/addons/libs/ecsy.module";
import "jspdf-autotable";
import Footer from "../../../../../examples/Footer";
import { tr } from "date-fns/locale";
import { companies } from '../companies.js';
import { styled } from "@mui/material/styles";
import dayjs from "dayjs";
import Typography from "@mui/material/Typography";
import RequiredLabelWithTooltip, { RequiredDot } from "../../../../../assets/theme/components/form/RequiredLabelWithTooltip";
import { DEFAULT_CUSTOMS_OFFICES } from "constants/customsOffices";
import CmrPrintDialog from "./CmrPrintDialog";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import EditIcon from "@mui/icons-material/Edit";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import LinkIcon from "@mui/icons-material/Link";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import CreateCustomer from "../crm/customer/CreateCustomer";
import CreateServiceProvider from "../crm/Service Provider/CreateServiceProvider";
import ShipmentFinanceModal, { FinanceDetailsButton } from "../crm/invoice/finance/shared/ShipmentFinanceModal";
import { AddRowButton, RemoveRowButton } from "components/RowActions";
import Drawer from "@mui/material/Drawer";
import ShipmentNotifications from "../OceanTMS/notifications/ShipmentNotifications";
import NotificationsLauncher from "../OceanTMS/notifications/NotificationsLauncher";
import { TrucksSection, CargoTruckLoads } from "./RoadTrucks";
import {
  cmrPayloadsForTrucks,
  duplicateTruck,
  emptyTruck,
  normalizeCargo,
  normalizeCargoList,
  setCargoTotal,
  trucksForPayload,
  trucksFromSaved,
} from "./roadTruckModel";
GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.js`;

const CreateShipment = () => {
  const navigate = useNavigate();
  const initialAddressState = {
    additionalInfo: [],
    gateway: "",
    country: "",
    city: "",
    district: "",
    latLong: "",
    zipcode: "",
    officeCode: "",
    brokerageName: "",
    pickupType: "Direct Pickup",
    deliveryType: "Direct Delivery",
  };

  const packingOptions = [
    { label: "Box" },
    { label: "Crate" },
    { label: "Pallet" },
    { label: "Roll" },
    { label: "Mix" },
    { label: "Loose" },
    { label: "Unpackaged or Unpacked" },
  ];

  const truckType = [
    { label: "Standard Truck" }, // Standart Kamyon
    { label: "Refrigerated Truck" }, // Soğutuculu Kamyon
    { label: "Container Truck" }, // Konteyner Taşıyan Kamyon
    { label: "Flatbed Truck" }, // Açık Kasa Kamyon
    { label: "Tanker Truck" }, // Tanker Kamyon
    { label: "Lowboy Truck" }, // Düşük Yükleme Kasalı Kamyon
    { label: "Dump Truck" }, // Damperli Kamyon
    { label: "Car Carrier Truck" }, // Araç Taşıyıcı Kamyon
    { label: "Tow Truck" }, // Çekici Kamyon
    { label: "Fire Truck" } // İtfaiye Kamyonu
  ];

  const incotermsOptions = [
    { label: "CFR" }, // Cost and Freight
    { label: "CIF" }, // Cost, Insurance and Freight
    { label: "CIP" }, // Carriage and Insurance Paid To
    { label: "CPT" }, // Carriage Paid To
    { label: "DAP" }, // Delivered at Place
    { label: "DAT" }, // Delivered at Terminal
    { label: "DPU" }, // Delivered at Place Unloaded
    { label: "DDP" }, // Delivered Duty Paid
    { label: "EXW" }, // Ex Works
    { label: "FAS" }, // Free Alongside Ship
    { label: "FCA" }, // Free Carrier
    { label: "FOB" }, // Free on Board
    { label: "FOT" }, // Free on Truck
    { label: "FOR" }, // Free on Rail
  ];

  const roadTransportSubOptions = [
    { label: "FTL-IMPORT" },
    { label: "FTL-EXPORT" },
    { label: "FTL-DOMESTIC" },
    { label: "FTL-TRANSIT" },
    { label: "LTL-IMPORT" },
    { label: "LTL-EXPORT" },
    { label: "LTL-DOMESTIC" },
    { label: "LTL-TRANSIT" },
  ];

  const imcoOptions = [
    { label: "(1.1) Substances and objects with a mass explosion hazard" },
    { label: "(1.2) Substances and objects with an explosion hazard but without a mass explosion hazard" },
    { label: "(1.3) Substances and objects with a fire hazard and a minor blast or minor projection hazard, or both, but without a mass explosion hazard" },
    { label: "(1.4) Substances and objects posing no significant hazard" },
    { label: "(1.6) Extremely insensitive substances without a mass explosion hazard" },
    { label: "(2.1) Flammable gases" },
    { label: "(2.2) Non-flammable, non-toxic gases" },
    { label: "(2.3) Toxic gases" },
    { label: "(3) Flammable liquids" },
    { label: "(4.1) Flammable solids, substances prone to spontaneous combustion, and solid desensitized explosives" },
    { label: "(4.2) Substances prone to spontaneous combustion" },
    { label: "(4.3) Substances emitting flammable gases when in contact with water" },
    { label: "(5.1) Oxidizing substances" },
    { label: "(5.2) Organic peroxides" },
    { label: "(6.1) Toxic substances" },
    { label: "(7) Radioactive substances" },
    { label: "(8) Corrosive substances" },
    { label: "(9) Miscellaneous dangerous substances and objects" },
  ];

  const LS_KEY = "customs_offices_v1";


  const customsOfficeOptions = React.useMemo(() => {
    try {
      const saved = localStorage.getItem(LS_KEY);
      if (saved) {
        const arr = JSON.parse(saved);
        if (Array.isArray(arr) && arr.length) return arr;
      }
    } catch {}
    return DEFAULT_CUSTOMS_OFFICES;
  }, []);


  const location = useLocation();
  const transferredData = location.state; // Eğer state boşsa undefined döner
  const [customerOptions, setCustomerOptions] = useState([]); // Options for Autocomplete
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [inputValue, setInputValue] = useState(""); // Kullanıcı girişini takip etmek için
  const [open, setOpen] = useState(false); // Listeyi kontrol etmek için
  const [partyOptions, setPartyOptions] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({
    customer: false,
    roadTransport: false,
    pickupDate: false,
  });
  const [connectRmblOpen, setConnectRmblOpen] = useState(false);
  const [existingRmbls, setExistingRmbls] = useState([]);
  const [rmblLoading, setRmblLoading] = useState(false);
  const [isCloneMode, setIsCloneMode] = useState(false);
  const [cargoErrors, setCargoErrors] = useState([]);
  const [customerModalOpen, setCustomerModalOpen] = useState(false);
  const [customerModalTarget, setCustomerModalTarget] = useState(null);
  const [serviceProviderModalOpen, setServiceProviderModalOpen] = useState(false);
  const [serviceProviderModalTarget, setServiceProviderModalTarget] = useState(null);

  const NEW_PARTY_OPTION = {
    id: "new-party",
    name: "+ New",
    type: "new",
  };

  // Same "+ New Account" entry the other party inputs have, for the
  // service provider inputs (opens the Create Service Provider form).
  const NEW_SERVICE_PROVIDER_OPTION = {
    id: "new-service-provider",
    name: "+ New Account",
    type: "new",
  };

  const getServiceProviderOptionLabel = (option) =>
      typeof option === "string" ? option : option?.name || "";

  const renderServiceProviderOption = (props, option) => (
      <li {...props} key={typeof option === "string" ? option : option.id}>
        {typeof option === "object" && option?.type === "new" ? (
            <strong style={{ color: "#1976d2" }}>+ New Account</strong>
        ) : (
            option
        )}
      </li>
  );

  // Manufacturer stays free text, but its list now also offers "+ New Account".
  const manufacturerFilter = createFilterOptions();
  const filterManufacturerOptions = (options, state) => [
    NEW_PARTY_OPTION,
    ...manufacturerFilter(
        options.filter((option) => option?.type !== "new"),
        state
    ),
  ];

  const serviceProviderFilter = createFilterOptions();
  const filterServiceProviderOptions = (options, state) => [
    NEW_SERVICE_PROVIDER_OPTION,
    ...serviceProviderFilter(
        options.filter((option) => typeof option === "string"),
        state
    ),
  ];

  const SAME_AS_CONSIGNEE_OPTION = {
    id: "same-as-consignee",
    name: "Same as Consignee",
    type: "sameAsConsignee",
  };

  useEffect(() => {
    const fetchCustomers = async () => {
      try {
        const response = await CrudService.getCustomers();

        const options = response.data.map((customer) => {
          const pickupAddress =
            customer.attributes?.operationAddresses?.[0]?.pickupAddress || "No Address";

          return {
            name: customer.attributes?.name || "Unnamed Customer", // Müşteri ismi
            id: customer.id, // Müşteri ID'si
            pickupAddress, // Pickup Address bilgisi
          };
        });

        setCustomerOptions(options); // Müşteri seçeneklerini güncelle
      } catch (error) {
        console.error("Müşteri verileri alınırken hata oluştu:", error);
      }
    };

    fetchCustomers();
  }, []);

  const [globalAgentOptions, setGlobalAgentOptions] = React.useState([]);

  React.useEffect(() => {
    const fetchGlobalAgents = async () => {
      try {
        const res = await CrudService.getGlobalAgents(); // senin servis adın neyse
        // res.data / res.globalAgents vs yapına göre uyarlayabilirsin:
        const list = res?.data?.data || res?.data || [];
        setGlobalAgentOptions(list);
      } catch (e) {
        console.error("getGlobalAgents error:", e);
        setGlobalAgentOptions([]);
      }
    };

    fetchGlobalAgents();
  }, []);



  const [salesRep, setSalesRep] = useState([]);
  const [salesRepOptions, setSalesRepOptions] = useState([]);

  useEffect(() => {
    const fetchSalesReps = async () => {
      try {
        const response = await CrudService.getUsers();
        const users = response.data;
        const formattedUsers = users.map(user => ({
          id: user.id,
          label: user.attributes.name
        }));
        setSalesRepOptions(formattedUsers);
      } catch (error) {
        console.error("Satış temsilcileri alınamadı:", error);
      }
    };
    fetchSalesReps();
  }, []);

  const [selectedCustomerSalesRepIds, setSelectedCustomerSalesRepIds] = useState([]);
  // Customer of the shipment being loaded for editing: its own Sales Rep is kept and the
  // customer's default reps are applied only when the user picks a customer. Applying them on
  // load replaced (or, for a customer with none, emptied) the saved Sales Rep on the next save.
  const loadedCustomerIdRef = useRef(undefined);

// 1) Customer seçilince customer detayını çek -> salesRep id’lerini sakla
  useEffect(() => {
    const run = async () => {
      const customerId = selectedCustomer?.id;   // ✅ value değil id
      if (
          loadedCustomerIdRef.current !== undefined &&
          String(customerId ?? "") === String(loadedCustomerIdRef.current ?? "")
      ) {
          loadedCustomerIdRef.current = undefined;
          return;
      }
      if (!customerId) {
        setSelectedCustomerSalesRepIds([]);
        setSalesRep([]);
        return;
      }

      try {
        const res = await CrudService.getCustomerById(customerId);
        const customer = res?.data?.attributes;
        const ids = Array.isArray(customer?.salesRep)
            ? customer.salesRep
                .map((x) => (typeof x === "string" ? x : (x?._id || x?.id)))
                .filter(Boolean)
            : [];

        setSelectedCustomerSalesRepIds(ids);
      } catch (e) {
        console.error("Customer detail fetch error:", e);
        setSelectedCustomerSalesRepIds([]);
        setSalesRep([]);
      }
    };

    run();
  }, [selectedCustomer?.id]);

// 2) salesRepOptions hazır olunca -> Sales Rep Autocomplete value set et
  useEffect(() => {
    if (!salesRepOptions?.length) return;

    const selected = salesRepOptions.filter((o) =>
        selectedCustomerSalesRepIds.some((id) => String(id) === String(o.id)) // ✅ o.value değil o.id
    );

    setSalesRep(selected);
  }, [salesRepOptions, selectedCustomerSalesRepIds]);

  const [shipmentData, setShipmentData] = useState({});

  const [loading, setLoading] = useState(false); // Yüklenme durumu
  const [isEditing, setIsEditing] = useState(false); // Düzenleme modu
  // Opening an existing shipment starts read-only so a stray click can't
  // change a saved value; the user has to explicitly hit "Edit" to unlock
  // the form. A brand new shipment (no id yet) is never read-only.
  const [readOnlyMode, setReadOnlyMode] = useState(false);
  // RMBL this shipment is already connected to (sent by the backend as `linkedRmbl`).
  const [linkedRmbl, setLinkedRmbl] = useState(null);
  const linkedRmblLabel = linkedRmbl ? linkedRmbl.rmblNumber || "an RMBL" : "";
  // Styled through sx like the other chips of the app: the theme breaks on Chip variant/color props.
  const linkedMasterChipSx = {
    fontWeight: 600,
    color: "#1e3a8a",
    backgroundColor: "#FFFFFF",
    border: "1px solid #B6CCF5",
  };
  const [financeModalOpen, setFinanceModalOpen] = useState(false);
  // CMRs shown in the print preview; null while it is closed.
  const [cmrDocuments, setCmrDocuments] = useState(null);
  const searchParams = new URLSearchParams(location.search); // Query parametrelerini yakalıyoruz
  const shipmentId = searchParams.get("id"); // URL'deki `id` parametresini alıyoruz
  const [activeShipmentId, setActiveShipmentId] = useState(shipmentId || "");
  const notificationsShipmentId = activeShipmentId || shipmentId;
  // Shipment notification links open the file with ?tab=notifications.
  const notificationsTab = searchParams.get("tab") === "notifications";
  const [notificationsOpen, setNotificationsOpen] = useState(notificationsTab);
  useEffect(() => {
    if (notificationsTab) setNotificationsOpen(true);
  }, [notificationsTab, location.search]);
  useEffect(() => {
    if (shipmentId) {
      setIsEditing(true); // Düzenleme modunu etkinleştiriyoruz
      setReadOnlyMode(true);
      fetchShipmentDetails(shipmentId); // Shipment detaylarını çekiyoruz
    }
  }, [shipmentId]);

  useEffect(() => {
    if (shipmentId) {
      setActiveShipmentId(shipmentId);
    }
  }, [shipmentId]);
  // A customer missing from the (active) customer list keeps its saved name instead
  // of being dropped, which made the next save store "Unknown Customer".
  const toSavedCustomerOption = (customerName) => {
      const name = String(customerName || "").trim();
      return name && name !== "Unknown Customer" ? { name } : null;
  };

  const fetchShipmentDetails = async (id) => {
    setLoading(true);
    try {
      const response = await CrudService.getShipmentById(id);
      const shipmentData = response.data.attributes;
      setLinkedRmbl(shipmentData.linkedRmbl || null);
      setShipmentNo(shipmentData.shipmentNo || ""); // Eğer shipmentNo varsa kaydediyor, yoksa boş bir string
      const incomingMBLCustomer = location.state?.mblCustomer || null;
      const customerNameToUse = incomingMBLCustomer || shipmentData.customer;
      const matchedCustomer = customerOptions.find(
          (opt) =>
              opt.name?.trim().toLowerCase() ===
              customerNameToUse?.trim().toLowerCase()
      );

      loadedCustomerIdRef.current = matchedCustomer?.id;
      setSelectedCustomer(matchedCustomer || toSavedCustomerOption(customerNameToUse));

      setSalesRep(
          Array.isArray(shipmentData.salesRep)
              ? salesRepOptions.filter(repOption => shipmentData.salesRep.includes(repOption.id))
              : []
      );
      setSelectedRoadTransportSubOption(
        roadTransportSubOptions.find(
          (opt) => opt.label === shipmentData.roadTransportType,
        ) || null,
      );
      // Metin ve sayısal değerler
      setShipper(shipmentData.shipper || "");
      setConsignee(shipmentData.consignee || "");
      setNotify(shipmentData.notify || "");
      setManufacturer(shipmentData.manufacturer || "");
      setBillTo(shipmentData.billTo || "");
      setCommodity(shipmentData.commodity || "");
      setQuoteNo(shipmentData.quoteNo || "");
      setHsCode(shipmentData.hsCode || "");
      setUnit(shipmentData.unit || "");
      setTotalCost(shipmentData.totalCost || 0);
      setT1DeclarationNumber(shipmentData.t1DeclarationNumber || "");
      setWeek(shipmentData.week || 0);
      setTransitTime(shipmentData.transitTime || 0);
      setCountryOfOrigin(shipmentData.countryOfOrigin || "");
      setOfficeCode(shipmentData.officeCode || "");
      setBrokerageName(shipmentData.brokerageName || "");
      setOperationType(shipmentData.operationType || "road");
      // Files saved before multi-truck get one truck from their file-level fields.
      const loadedTrucks = trucksFromSaved(shipmentData);
      setTrucks(loadedTrucks);
      setCargoDetails(normalizeCargoList(shipmentData.cargoDetails || [], loadedTrucks));

      // Adres bilgileri
      if (shipmentData?.pickupLocation) {
        setPickupLocation({
          additionalInfo: shipmentData.pickupLocation?.additionalInfo || "",
          latLong: shipmentData.pickupLocation?.latLong || "",
          district: shipmentData.pickupLocation?.district || "",
          city: shipmentData.pickupLocation?.city || "",
          country: shipmentData.pickupLocation?.country || "",
          zipcode: shipmentData.pickupLocation?.zipcode || "",
          serviceProvider: shipmentData.pickupLocation?.serviceProvider || "",
          pickupType: shipmentData.pickupLocation?.pickupType || "",
        });
        const foundCountry = countryOptions.find(
            (option) => option.label === shipmentData.pickupLocation?.country
        );
        setSelectedCountry(foundCountry || null);
      } else {
        setPickupLocation({
          additionalInfo: "",
          latLong: "",
          district: "",
          city: "",
          country: "",
          zipcode: "",
          serviceProvider: "",
          pickupType: "",
        });
        setSelectedCountry(null);
      }

      setDeliveryLocation({
        additionalInfo: shipmentData.deliveryLocation?.additionalInfo || "",
        gateway: shipmentData.deliveryLocation?.gateway || "",
        latLong: shipmentData.deliveryLocation?.latLong || "",
        district: shipmentData.deliveryLocation?.district || "",
        city: shipmentData.deliveryLocation?.city || "",
        country: shipmentData.deliveryLocation?.country || "",
        zipcode: shipmentData.deliveryLocation?.zipcode || "",
        serviceProvider: shipmentData.deliveryLocation?.serviceProvider || "",
        deliveryType: shipmentData.deliveryLocation?.deliveryType || "Direct Delivery",
      });

      setExportLocation({
        additionalInfo: shipmentData.exportLocation?.additionalInfo || [],
        latLong: shipmentData.exportLocation?.latLong || "",
        district: shipmentData.exportLocation?.district || "",
        city: shipmentData.exportLocation?.city || "",
        country: shipmentData.exportLocation?.country || "",
        zipcode: shipmentData.exportLocation?.zipcode || "",
        officeCode: shipmentData.exportLocation?.officeCode || "",
        brokerageName: shipmentData.exportLocation?.brokerageName || "",
      });

      const foundCountry = countryOptions.find(
          (option) => option.label === shipmentData.deliveryLocation?.country
      );
      setSelectedDeliveryCountry(foundCountry || null);

      const foundExportCountry = countryOptions.find(
          (option) =>
              option.label === (shipmentData.exportLocation?.exportCountry || shipmentData.exportLocation?.country) ||
              option.code === (shipmentData.exportLocation?.exportCountry || shipmentData.exportLocation?.country)
      );

      setSelectedExportCountry(foundExportCountry || null);

      setImportLocation({
        importCountry: shipmentData.importLocation?.importCountry || "",
        additionalInfo: shipmentData.importLocation?.additionalInfo || [],
        latLong: shipmentData.importLocation?.latLong || "",
        district: shipmentData.importLocation?.district || "",
        city: shipmentData.importLocation?.city || "",
        country: shipmentData.importLocation?.country || "",
        zipcode: shipmentData.importLocation?.zipcode || "",
        officeCode: shipmentData.importLocation?.officeCode || "",
        brokerageName: shipmentData.importLocation?.brokerageName || "",
      });
      // 👇 Autocomplete için importCountry objesini bul ve set et
      const foundImportCountry = countryOptions.find(
          (option) =>
              option.label === (shipmentData.importLocation?.importCountry || shipmentData.importLocation?.country) ||
              option.code === (shipmentData.importLocation?.importCountry || shipmentData.importLocation?.country)
      );

      setSelectedImportCountry(foundImportCountry || null);
      setPickupDate(
        shipmentData.pickupDate ? new Date(shipmentData.pickupDate) : null,
      );
      setEstimatedDeliveryDate(
        shipmentData.estimatedDeliveryDate
          ? new Date(shipmentData.estimatedDeliveryDate)
          : null,
      );
      setRequestedDeliveryDate(
        shipmentData.requestedDeliveryDate
          ? new Date(shipmentData.requestedDeliveryDate)
          : null,
      );
      setEstimatedDeparture(
        shipmentData.estimatedDeparture
          ? new Date(shipmentData.estimatedDeparture)
          : null,
      );
      setActualDeparture(
        shipmentData.actualDeparture
          ? new Date(shipmentData.actualDeparture)
          : null,
      );
      setActualDelivery(
        shipmentData.actualDelivery
          ? new Date(shipmentData.actualDelivery)
          : null,
      );
      setAppointmentDate(
        shipmentData.appointmentDate
          ? new Date(shipmentData.appointmentDate)
          : null,
      );
      setProofOfDelivery(
        shipmentData.proofOfDelivery
          ? new Date(shipmentData.proofOfDelivery)
          : null,
      );

      setPickupTime(
        shipmentData.pickupTime || null
      );
      setEstimatedDeliveryTime(
        shipmentData.estimatedDeliveryTime
        || null,
      );
      setRequestedDeliveryTime(
        shipmentData.requestedDeliveryTime
        || null,
      );
      setEstimatedDepartureTime(
        shipmentData.estimatedDepartureTime
        || null,
      );
      setActualDepartureTime(
        shipmentData.actualDepartureTime
        || null,
      );
      setActualDeliveryTime(
        shipmentData.actualDeliveryTime
        || null,
      );
      setAppointmentTime(
        shipmentData.appointmentTime
        || null,
      );
      setProofOfDeliveryTime(
        shipmentData.proofOfDeliveryTime
        || null,
      );

      // Seçenekler ve dokümanlar
      setSelectedCountries(
        shipmentData.carbonFootprint?.plannedRouteCountries.map((country) => ({
          label: country, // Autocomplete'de görüntülenecek ülke ismi
          code:
            countryOptions.find((opt) => opt.label === country)?.code ||
            country, // Eğer varsa ülke kodu
        })) || [],
      );
      setEmissionFactor(shipmentData.carbonFootprint.emissionFactor || 0);
      setTotalCarbonEmissions(
        shipmentData.carbonFootprint.totalCarbonEmissions || 0,
      );
      setExportDeclaration(shipmentData.exportDeclaration || null);
      setImportDeclaration(shipmentData.importDeclaration || null);
      setAtr(shipmentData.atr || null);
      setCmr(shipmentData.cmr || null);
      setConfirmationMail(shipmentData.confirmationMail || null);
      setT1t2(shipmentData.t1t2 || null);
      setPackingList(shipmentData.packingList || null);
      setCommercialInvoice(shipmentData.commercialInvoice || null);
      setSignedCmr(shipmentData.signedCmr || null);
      setClosedT1t2(shipmentData.closedT1t2 || null);
      setLinehaulCarrier(shipmentData.linehaulCarrier || null);
      setPickupCarrier(shipmentData.pickupCarrier || null);
      setCarrierBroker(shipmentData.carrierBroker || null);

      setSallingRate(shipmentData.sallingRate || "");
      setCurrency(shipmentData.currency || "");
      setProfit(shipmentData.profit || 0);
      setLocationHistory(shipmentData.locationHistory || "");
      setCustomDetail({
        responsibility: shipmentData?.customDetail?.responsibility || false,
        customNote: shipmentData?.customDetail?.customNote || "",
        customRefNo: shipmentData?.customDetail?.customRefNo || "",
        responsibilityImport: shipmentData?.customDetail?.responsibilityImport || false,
        customNoteImport : shipmentData?.customDetail?.customNoteImport  || "",
      });
      setIsADR(shipmentData.adr || false);
      setImco(shipmentData.imco || null);

      const matchedServiceProvider = serviceProviders.find(
        (opt) =>
          opt?.trim()?.toLowerCase() === shipmentData?.serviceProvider?.trim()?.toLowerCase()
      );

      setSelectedServiceProvider(matchedServiceProvider || null);

      setBuyingRateCurrency(shipmentData.buyingRateCurrency || "EUR");

      setPickupRate(shipmentData.pickupRate || null);
      setPickupRateCurrency(shipmentData.pickupRateCurrency || null);

      setDeliveryRate(shipmentData.deliveryRate || null);
      setDeliveryRateCurrency(shipmentData.deliveryRateCurrency || null);

      setExportCustomsRate(shipmentData.exportCustomsRate || null);
      setExportCustomsRateCurrency(shipmentData.exportCustomsRateCurrency || null);

      setImportCustomsRate(shipmentData.importCustomsRate || null);
      setImportCustomsRateCurrency(shipmentData.importCustomsRateCurrency || null);

      setSellingRate(shipmentData.sellingRate || null);
      setSellingRateCurrency(shipmentData.sellingRateCurrency || null);
    } catch (error) {
      console.error("Error fetching shipment details:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const [customersRes, agentsRes] = await Promise.all([
          CrudService.getCustomers(),
          CrudService.getGlobalAgents(),
        ]);

        const customers = (customersRes.data || []).map((c) => ({
          id: c.id,
          name: c.attributes?.name || "Unnamed Customer",
          type: "customer",
        }));

        const agents = (agentsRes.data || []).map((a) => ({
          id: a.id,
          name: a.attributes?.name || a.name || "Unnamed Global Agent",
          type: "agent",
        }));

        const merged = [...customers, ...agents].sort((x, y) =>
            (x.name || "").localeCompare(y.name || "")
        );

        setCustomerOptions(customers);  // ✅ EKLE
        setPartyOptions(merged);
      } catch (err) {
        console.error("Options alınırken hata oluştu:", err);
      }
    };

    fetchOptions();
  }, []);

// companies (string[]) + partyOptions (object[]) => string[]
  const shipperConsigneeOptions = React.useMemo(() => {
    const companyItems = (companies || [])
        .map((name) => String(name || "").trim())
        .filter(Boolean)
        .map((name) => ({
          id: `company-${name.toLowerCase()}`,
          name,
          type: "company",
        }));

    const partyItems = (partyOptions || [])
        .filter((p) => p?.name)
        .map((p) => ({
          id: `${p.type}-${p.id}`,
          name: String(p.name).trim(),
          type: p.type, // "customer" | "agent"
        }));

    // unique by (type + name) (aynı isim farklı tipte olabilir)
    const map = new Map();
    [...companyItems, ...partyItems].forEach((item) => {
      const key = `${item.type}::${item.name.toLowerCase()}`;
      if (!map.has(key)) map.set(key, item);
    });

    return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));
  }, [partyOptions, companies]);

  const findOptionByName = (name) => {
    const target = String(name || "").trim().toLowerCase();

    if (!target) return null;

    return (
        shipperConsigneeOptions.find(
            (o) => String(o.name || "").trim().toLowerCase() === target
        ) || {
          id: `manual-${target}`,
          name,
          type: "manual",
        }
    );
  };

  const handleCustomerCreatedFromModal = (createdCustomer) => {
    const attr = createdCustomer?.attributes || createdCustomer;

    const newOption = {
      id: createdCustomer?.id || attr?._id || Date.now(),
      name: attr?.name || "Unnamed Customer",
      type: "customer",
    };

    setPartyOptions((prev) => {
      const exists = prev.some(
          (item) =>
              item.type === "customer" &&
              item.name?.toLowerCase() === newOption.name.toLowerCase()
      );

      return exists ? prev : [...prev, newOption];
    });

    if (customerModalTarget === "shipper") setShipper(newOption.name);
    if (customerModalTarget === "consignee") setConsignee(newOption.name);
    if (customerModalTarget === "notify") setNotify(newOption.name);
    if (customerModalTarget === "manufacturer") setManufacturer(newOption.name);
    if (customerModalTarget === "customer") {
      setSelectedCustomer(newOption);
      setInputValue(newOption.name);
    }

    setCustomerModalOpen(false);
    setCustomerModalTarget(null);
  };

  const handleServiceProviderCreatedFromModal = (createdProvider) => {
    const attr = createdProvider?.attributes || createdProvider;
    const name = attr?.name || "Unnamed Service Provider";

    setServiceProviders((prev) =>
        prev.some((item) => String(item).toLowerCase() === name.toLowerCase())
            ? prev
            : [...prev, name]
    );

    if (serviceProviderModalTarget === "pickup") {
      handleStateChange(setPickupLocation, "serviceProvider", name);
    }
    if (serviceProviderModalTarget === "delivery") {
      handleStateChange(setDeliveryLocation, "serviceProvider", name);
    }
    if (serviceProviderModalTarget === "customsExport") {
      handleStateChange(setCustomDetail, "customNote", name);
    }
    if (serviceProviderModalTarget === "customsImport") {
      handleStateChange(setCustomDetail, "customNoteImport", name);
    }
    if (serviceProviderModalTarget === "exportBrokerage") {
      handleStateChange(setExportLocation, "brokerageName", name);
    }
    if (serviceProviderModalTarget === "importBrokerage") {
      handleStateChange(setImportLocation, "brokerageName", name);
    }

    setServiceProviderModalOpen(false);
    setServiceProviderModalTarget(null);
  };

  useEffect(() => {
    if (!shipmentId && !transferredData) return;

    // transferredData varsa edit fetch yapma
    if (transferredData) {
      fillFormWithTransferredData(transferredData);
      return;
    }

    // edit ise: customerOptions/salesRepOptions hazırsa fetch
    if (shipmentId && customerOptions.length > 0 && salesRepOptions.length > 0) {
      fetchShipmentDetails(shipmentId);
    }
  }, [shipmentId, transferredData, customerOptions.length, salesRepOptions.length]);


  const fillFormWithTransferredData = (data) => {
    const matchedCustomer = customerOptions.find((opt) =>
        opt.name?.toLowerCase().trim() === data.customer?.toLowerCase().trim()
    );
    setSelectedCustomer(matchedCustomer || toSavedCustomerOption(data.customer));



    const matchedServiceProvider = serviceProviders.find(
        (sp) =>
            sp.name?.toLowerCase().trim() === data.serviceProvider?.toLowerCase().trim()
    );
    setSelectedServiceProvider(matchedServiceProvider || null);

    setPickupDate(
        transferredData.pickupDate
            ? dayjs(transferredData.pickupDate, "DD-MM-YYYY").toDate()
            : null
    );
    setEstimatedDeliveryDate(
        transferredData.deliveryDate
            ? dayjs(transferredData.deliveryDate, "DD-MM-YYYY").toDate()
            : null
    );

    setActualDeparture(
        transferredData.departureDate
            ? dayjs(transferredData.departureDate, "DD-MM-YYYY").toDate()
            : null
    );

    setWeek(data.week || "");
    setShipper(data.shipper || "");
    setConsignee(data.consignee || "");
    setTransitTime(data.transitTime || "");
    if (data.plateNumber) {
      setTrucks((prev) => prev.map((t, i) => (i === 0 ? { ...t, plate: data.plateNumber } : t)));
    }

    setSalesRep(
        Array.isArray(data.salesRep)
            ? salesRepOptions.filter(repOption =>
                data.salesRep.includes(repOption.id)
            )
            : []
    );

    setSelectedRoadTransportSubOption(
        roadTransportSubOptions.find(
            (opt) => opt.label === (data.roadTransportType || "").toUpperCase(),
        ) || null,
    );
    setSallingRate(data.sellingRate || "");
    setCurrency(data.sellingCurrency || "EUR");
    setProfit(data.grossProfit || 0);
  };




  const [shipmentNo, setShipmentNo] = useState(0);
  const [pickupLocation, setPickupLocation] = useState(initialAddressState);
  const [deliveryLocation, setDeliveryLocation] = useState(initialAddressState);
  const [exportLocation, setExportLocation] = useState(initialAddressState);
  const [selectedExportCountry, setSelectedExportCountry] = useState(null);
  const [importLocation, setImportLocation] = useState(initialAddressState);
  const [selectedImportCountry, setSelectedImportCountry] = useState(null);
  const [grossWeight, setGrossWeight] = useState("");
  const [notStackable, setNotStackable] = useState(true); // Default olarak Not Stackable true
  const [stackingFactor, setStackingFactor] = useState(2); // Stacking Factor
  const [operationType, setOperationType] = useState("road"); // Operation type (road, sea, air, rail)
  const [countryOfOrigin, setCountryOfOrigin] = useState(null);
  const [commodity, setCommodity] = useState("");
  const [quoteNo, setQuoteNo] = useState("");
  const [hsCode, setHsCode] = useState("");
  const [unit, setUnit] = useState("");
  const [totalCost, setTotalCost] = useState(0);
  const [t1DeclarationNumber, setT1DeclarationNumber] = useState("");
  const [week, setWeek] = useState(0);
  const [transitTime, setTransitTime] = useState(0);
  const [shipper, setShipper] = useState("");
  const [consignee, setConsignee] = useState("");
  const [manufacturer, setManufacturer] = useState("");
  const [notify, setNotify] = useState("");
  const [billTo, setBillTo] = useState("");
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [officeCode, setOfficeCode] = useState("");
  const [brokerageName, setBrokerageName] = useState("");
  const [customDetail, setCustomDetail] = useState({
    importResponsibility: false,
    exportResponsibility: false,
  });
  const [isADR, setIsADR] = useState(false); // ADR/DG anahtarı
  const [imco, setImco] = useState(null); // Seçilen IMCO sınıfı
  const [serviceProviders, setServiceProviders] = useState([]); // Array olmalı
  const [selectedServiceProvider, setSelectedServiceProvider] = useState(null);
  const [emissionFactor, setEmissionFactor] = useState(0);
  const [totalCarbonEmissions, setTotalCarbonEmissions] = useState(0);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedDeliveryCountry, setSelectedDeliveryCountry] = useState(null);
  const [pickupDate, setPickupDate] = useState(null);
  const [estimatedDeliveryDate, setEstimatedDeliveryDate] = useState(null);
  const [requestedDeliveryDate, setRequestedDeliveryDate] = useState(null);
  const [estimatedDeparture, setEstimatedDeparture] = useState(null);
  const [actualDeparture, setActualDeparture] = useState(null);
  const [actualDelivery, setActualDelivery] = useState(null);
  const [proofOfDelivery, setProofOfDelivery] = useState(null);
  const [appointmentDate, setAppointmentDate] = useState(null);
  const [selectedRoadTransportSubOption, setSelectedRoadTransportSubOption] = useState(null);
  // Vehicles of the file (plate, trailer, driver, CMR / seal, buying rate, dates); see roadTruckModel.js.
  const [trucks, setTrucks] = useState(() => [emptyTruck()]);
  const [pickupTime, setPickupTime] = useState("");
  const [estimatedDeliveryTime, setEstimatedDeliveryTime] = useState("");
  const [estimatedDepartureTime, setEstimatedDepartureTime] = useState("");
  const [requestedDeliveryTime, setRequestedDeliveryTime] = useState("");
  const [actualDepartureTime, setActualDepartureTime] = useState("");
  const [actualDeliveryTime, setActualDeliveryTime] = useState("");
  const [proofOfDeliveryTime, setProofOfDeliveryTime] = useState("");
  const [appointmentTime, setAppointmentTime] = useState("");
  const [exportDeclaration, setExportDeclaration] = useState(null);
  const [importDeclaration, setImportDeclaration] = useState(null);
  const [atr, setAtr] = useState(null);
  const [cmr, setCmr] = useState(null);
  const [confirmationMail, setConfirmationMail] = useState(null);
  const [t1t2, setT1t2] = useState(null);
  const [packingList, setPackingList] = useState(null);
  const [commercialInvoice, setCommercialInvoice] = useState(null);
  const [signedCmr, setSignedCmr] = useState(null);
  const [closedT1t2, setClosedT1t2] = useState(null);
  const [linehaulCarrier, setLinehaulCarrier] = useState(null);
  const [pickupCarrier, setPickupCarrier] = useState(null);
  const [carrierBroker, setCarrierBroker] = useState(null);
  const [sallingRate, setSallingRate] = useState(null);
  const [currency, setCurrency] = useState("");
  const [profit, setProfit] = useState(0); // Başlangıç değeri null
  const [quoteNoList, setQuoteNoList] = useState([]); // Açılır menü seçenekleri
  const [selectedQuoteNo, setSelectedQuoteNo] = useState(""); // Seçilen değer
  const [quoteDetails, setQuoteDetails] = useState([]); // Tüm quote detaylarını tutar
  const [locationHistory, setLocationHistory] = useState([]);
  const [refreshLocationHistory, setRefreshLocationHistory] = useState(false);
  // The file's buying rate is the total of its trucks' rates.
  const buyingRate = trucksForPayload(trucks).buyingRate;
  const [buyingRateCurrency, setBuyingRateCurrency] = useState("EUR");
  const [pickupRate, setPickupRate] = useState("");
  const [pickupRateCurrency, setPickupRateCurrency] = useState("EUR");
  const [deliveryRate, setDeliveryRate] = useState("");
  const [deliveryRateCurrency, setDeliveryRateCurrency] = useState("EUR");
  const [exportCustomsRate, setExportCustomsRate] = useState("");
  const [exportCustomsRateCurrency, setExportCustomsRateCurrency] = useState("EUR");
  const [importCustomsRate, setImportCustomsRate] = useState("");
  const [importCustomsRateCurrency, setImportCustomsRateCurrency] = useState("EUR");
  const [sellingRate, setSellingRate] = useState("");
  const [sellingRateCurrency, setSellingRateCurrency] = useState("EUR");
  const [pickupCityOptions, setPickupCityOptions] = useState([]);
  const [deliveryCityOptions, setDeliveryCityOptions] = useState([]);
  const [pickupCityLoading, setPickupCityLoading] = useState(false);
  const [deliveryCityLoading, setDeliveryCityLoading] = useState(false);

  const fetchCitiesByCountry = async (countryLabel) => {
    const country = (countryLabel || "").trim();
    if (!country) return [];

    const res = await CrudService.getCitiesByCountry(country);

    const raw =
        res?.data?.data ||
        res?.data?.cities ||
        res?.data?.attributes?.data ||
        res?.data ||
        [];

    return Array.isArray(raw)
        ? raw.map((city) => ({ label: String(city) }))
        : [];
  };

  useEffect(() => {
    const run = async () => {
      const country = selectedCountry?.label || pickupLocation.country;

      if (!country) {
        setPickupCityOptions([]);
        return;
      }

      try {
        setPickupCityLoading(true);
        const cities = await fetchCitiesByCountry(country);
        setPickupCityOptions(cities);
      } catch (e) {
        console.error("Pickup cities fetch error:", e);
        setPickupCityOptions([]);
      } finally {
        setPickupCityLoading(false);
      }
    };

    run();
  }, [selectedCountry, pickupLocation.country]);

  useEffect(() => {
    const run = async () => {
      const country = selectedDeliveryCountry?.label || deliveryLocation.country;

      if (!country) {
        setDeliveryCityOptions([]);
        return;
      }

      try {
        setDeliveryCityLoading(true);
        const cities = await fetchCitiesByCountry(country);
        setDeliveryCityOptions(cities);
      } catch (e) {
        console.error("Delivery cities fetch error:", e);
        setDeliveryCityOptions([]);
      } finally {
        setDeliveryCityLoading(false);
      }
    };

    run();
  }, [selectedDeliveryCountry, deliveryLocation.country]);

  // Generic state handler
  const handleStateChange = (setter, key, value) => {
    setter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  useEffect(() => {
    const fetchShipmentNo = async () => {
      try {
        // Yeni gönderi için gereken `payload`'u burada tanımlayın
        const payload = {};
        // ObjectId doğrulaması
        if (payload._id && !mongoose.Types.ObjectId.isValid(payload._id)) {
          return; // Hata durumunda fonksiyonu durdur
        }

        // API çağrısı
        const response = await CrudService.getShipmentNumber(payload);
        const shipmentNoValue = response?.data?.attributes?.shipmentNo;

        if (shipmentNoValue) {
          setShipmentNo(shipmentNoValue);
        } else {
          console.error("Shipment number not found in response:", response);
        }
      } catch (error) {
        console.error("Failed to fetch shipment number:", error);
      }
    };

    fetchShipmentNo();
  }, []);

  const ColoredSwitch = styled(Switch)(({ ownerState }) => ({
    '& .MuiSwitch-thumb': {
      backgroundColor: ownerState.checked ? 'orange' : 'white',
    },
    '& .MuiSwitch-track': {
      backgroundColor: ownerState.checked ? 'orange' : 'lightgray',
      opacity: 1, // Bulanıklık veya yarı saydamlığı sıfırla
      border: '1px solid lightgray', // Çerçeve görünümü istiyorsan ekle
    },
  }));

  const renderCountryAutocomplete = (
      label,
      options,
      value,
      onChange,
      setLocationState,
      handleStateChange,
      fieldName = "country"
  ) => (
      <Autocomplete
          value={value || null}
          onChange={(event, newValue) => {
            onChange(newValue);
            // Quote No gibi konum dışı kullanımlarda bu iki parametre verilmiyor; çağırmak hata fırlatıyordu
            if (typeof handleStateChange === "function" && setLocationState) {
              handleStateChange(
                  setLocationState,
                  fieldName,
                  newValue?.label || ""
              );
            }
          }}
          options={options}
          getOptionLabel={(option) => option?.label || ""}
          isOptionEqualToValue={(option, value) =>
              option?.label === value?.label
          }
          renderOption={({ key: optionKey, ...props }, option) => (
              <li key={optionKey} {...props} style={{ display: "flex", alignItems: "center" }}>
                {option.flagUrl && (
                    <img
                        src={option.flagUrl}
                        alt={`${option.label} flag`}
                        width="20"
                        height="15"
                        style={{ marginRight: 8 }}
                    />
                )}
                {option.label}
              </li>
          )}
          renderInput={(params) => (
              <TextField
                  {...params}
                  label={label}
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    "& .MuiInputBase-root": { height: 40 },
                    "& .MuiOutlinedInput-input": { padding: "0 14px" }
                  }}
              />
          )}
      />
  );


  const renderCountryOfOriginAutocomplete = (
      label,
      options,
      value,
      onChange
  ) => (
      <Autocomplete
          value={options.find((option) => option.label === value) || null}
          onChange={(event, newValue) =>
              onChange(newValue ? newValue.label : "")
          }
          options={options}
          getOptionLabel={(option) => option?.label || ""}
          isOptionEqualToValue={(option, value) =>
              option?.label === value?.label
          }
          renderOption={({ key: optionKey, ...props }, option) => (
              <li key={optionKey} {...props} style={{ display: "flex", alignItems: "center" }}>
                {option.flagUrl && (
                    <img
                        src={option.flagUrl}
                        alt={`${option.label} flag`}
                        width="20"
                        height="15"
                        style={{ marginRight: 8 }}
                    />
                )}
                {option.label}
              </li>
          )}
          renderInput={(params) => (
              <TextField
                  {...params}
                  label={label}
                  variant="outlined"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  sx={{
                    "& .MuiInputBase-root": { height: 40 },
                    "& .MuiOutlinedInput-input": { padding: "0 14px" }
                  }}
              />
          )}
      />
  );

  const calculateTransitTime = () => {
    if (pickupDate && estimatedDeliveryDate) {
      const diffTime = estimatedDeliveryDate - pickupDate;
      const diffDays = diffTime / (1000 * 60 * 60 * 24);
      return Math.floor(diffDays);
    }
    return 0;
  };

  const calculateWeekNumber = () => {
    return pickupDate ? getISOWeek(pickupDate) : 0;
  };



  const [cargoDetails, setCargoDetails] = useState([
    {
      commodity: "",
      hsCode: "",
      selectedPackingType: "",
      unitQuantity: "",
      grossWeight: "",
      notStackable: true,
      stackingFactor: 2,
      cbm: 0,
      ldm: 0,
      chargeableWeight: 0,
      description: "",
      operationType: "road",
      incoterm: "",
      goodsOriginCountry: ""
    },
  ]);

  // Yeni bir cargo eklemek için fonksiyon
  const addCargoDetail = () => {
    setCargoDetails([
      ...cargoDetails,
      {
        commodity: "",
        hsCode: "",
        selectedPackingType: "",
        unitQuantity: 0,
        grossWeight: 0,
        notStackable: true,
        stackingFactor: 2,
        cbm: 0,
        ldm: 0,
        chargeableWeight: 0,
        description: "",
        operationType: "road",
        incoterm: "",
        goodsOriginCountry: ""
      },
    ]);
  };

  // Was `const updated = [...cargoDetails]; updated[index][field] = value;
  // setCargoDetails(updated)` -- that shallow-copies the ARRAY but still
  // mutates the SAME row object, and reads `cargoDetails` from this
  // closure rather than from the latest state. Under React's batching, two
  // updates fired close together (fast typing, or another cargo-updating
  // call in the same tick) both start from the same pre-batch snapshot, so
  // the second call's setCargoDetails silently discards the first one's
  // change -- a value the user just typed could vanish, intermittently,
  // with no error. The functional form + a fresh row object fixes both.
  const updateCargoDetails = (index, field, value) => {
    setCargoDetails((prev) =>
        prev.map((cargo, i) =>
            // With more trucks a typed measure is spread over their per-truck loads.
            i === index ? setCargoTotal(cargo, field, value ?? 0, trucks) : cargo
        )
    );
  };
  // With more than one truck the totals are shown for every file, not only LTL.
  const loadsPerTruck = trucks.length > 1;


  const calculateTotals = () => {
    const totalLdm = cargoDetails.reduce((acc, cargo) => acc + cargo.ldm, 0);
    const totalCbm = cargoDetails.reduce((acc, cargo) => acc + cargo.cbm, 0);
    const totalChargeableWeight = cargoDetails.reduce(
      (acc, cargo) => acc + parseFloat(cargo.chargeableWeight),
      0,
    );

    return { totalLdm, totalCbm, totalChargeableWeight };
  };

  useEffect(() => {
    const totals = calculateTotals(); // Toplamları hesapla
    setTotals(totals); // Toplamları state’e ata
  }, [cargoDetails]); // cargoDetails her güncellendiğinde çalışır

  const [totals, setTotals] = useState({
    totalLdm: 0,
    totalCbm: 0,
    totalChargeableWeight: 0,
  });

  const validateOnlyTheseFields = () => {
    const errors = {
      customer: !selectedCustomer,
      roadTransport: !selectedRoadTransportSubOption,
      pickupDate: !pickupDate,
    };

    const cErrors = (cargoDetails || []).map((c) => ({
      unitQuantity: !(Number(c.unitQuantity) > 0),
      grossWeight: !(Number(c.grossWeight) > 0),
    }));

    const hasCargoError = cErrors.some(
        (e) => e.unitQuantity || e.grossWeight
    );

    setFieldErrors(errors);
    setCargoErrors(cErrors);

    const hasTopError = Object.values(errors).some(Boolean);
    const hasAnyError = hasTopError || hasCargoError;

    if (hasAnyError) {
      // Names below are the exact on-screen labels of the required fields.
      const missing = [];
      if (errors.customer) missing.push(isEditing ? "Selected Customer" : "Search Customer");
      if (errors.roadTransport) missing.push("Road Transport Mode");
      if (errors.pickupDate) missing.push("Pickup Date");
      cErrors.forEach((e, i) => {
        const prefix = cErrors.length > 1 ? `Cargo ${i + 1} - ` : "";
        if (e.unitQuantity) missing.push(`${prefix}Unit Quantity`);
        if (e.grossWeight) missing.push(`${prefix}Gross Weight (kg)`);
      });
      setErrorMessage(`Please fill required fields: ${missing.join(", ")}`);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
    return !hasAnyError;
  };

  const isRequiredFieldsFilled = () => {
    const topValid =
        !!selectedCustomer &&
        !!selectedRoadTransportSubOption &&
        !!pickupDate;

    const cargoValid = (cargoDetails || []).every((c) =>
        Number(c.unitQuantity) > 0 &&
        Number(c.grossWeight) > 0
    );

    return topValid && cargoValid;
  };

  const isPrintCmrDisabled = loading || !isRequiredFieldsFilled();

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error"
  });


  const buildShipmentPayload = () => {
    const totals = calculateTotals();

    const carbonFootprintData = {
      plannedRouteCountries: selectedCountries
          .filter((country) => country && country.label)
          .map((country) => country.label),
      emissionFactor,
      totalCarbonEmissions,
    };

    return {
      customer: selectedCustomer?.name || "Unknown Customer",
      salesRep: salesRep.map((rep) => rep.id),
      roadTransportType: selectedRoadTransportSubOption?.label || "",
      shipper,
      consignee,
      notify,
      manufacturer,
      billTo,
      commodity,
      quoteNo,
      hsCode,
      unit,
      grossWeight,
      cargoDetails: normalizeCargoList(cargoDetails, trucks),
      // trucks + file-level truckType, plateContainerNumber, cmrNumber, sealNumber, buyingRate
      ...trucksForPayload(trucks),
      totals: {
        totalLdm: totals.totalLdm,
        totalCbm: totals.totalCbm,
        totalChargeableWeight: totals.totalChargeableWeight,
      },
      notStackable,
      stackingFactor,
      operationType,
      pickupLocation: { ...pickupLocation },
      deliveryLocation: { ...deliveryLocation },
      exportLocation: { ...exportLocation },
      importLocation: { ...importLocation },
      countryOfOrigin,
      pickupDate,
      estimatedDeliveryDate,
      requestedDeliveryDate,
      estimatedDeparture,
      actualDeparture,
      actualDelivery,
      proofOfDelivery,
      appointmentDate,
      pickupTime,
      estimatedDeliveryTime,
      requestedDeliveryTime,
      estimatedDepartureTime,
      actualDepartureTime,
      actualDeliveryTime,
      proofOfDeliveryTime,
      appointmentTime,
      t1DeclarationNumber,
      transitTime,
      week,
      carbonFootprint: carbonFootprintData,
      sallingRate,
      currency,
      profit,
      locationHistory,
      customDetail: {
        responsibility: customDetail?.responsibility || false,
        customNote: customDetail?.customNote || "",
        customRefNo: customDetail?.customRefNo || "",
        responsibilityImport: customDetail?.responsibilityImport || false,
        customNoteImport: customDetail?.customNoteImport || "",
      },
      adr: isADR,
      imco: imco || "",
      serviceProvider: selectedServiceProvider || "",
      buyingRateCurrency,
      pickupRate,
      pickupRateCurrency,
      deliveryRate,
      deliveryRateCurrency,
      exportCustomsRate,
      exportCustomsRateCurrency,
      importCustomsRate,
      importCustomsRateCurrency,
      sellingRate,
      sellingRateCurrency,
    };
  };

  const submitHandler = async (e, buttonType, shouldPrintCmr = false) => {
    e.preventDefault();

    const isValid = validateOnlyTheseFields();
    if (!isValid) return;

    const shipmentData = buildShipmentPayload();
    const willUpdate = isEditing && shipmentId && !isCloneMode;

    const formData = new FormData();
    const fileMap = {
      exportDeclaration,
      importDeclaration,
      atr,
      cmr,
      confirmationMail,
      t1t2,
      packingList,
      commercialInvoice,
      signedCmr,
      closedT1t2,
      linehaulCarrier,
      pickupCarrier,
      carrierBroker,
    };
    if (!willUpdate) {
      Object.entries(fileMap).forEach(([fieldName, fileValue]) => {
        if (typeof fileValue === "string" && fileValue) {
          shipmentData[fieldName] = fileValue;
        }
      });
    }

    Object.entries(fileMap).forEach(([fieldName, fileArray]) => {
      appendFileSmart(fieldName, fileArray);
    });

    function appendFileSmart(fieldName, fileArray) {
      if (fileArray?.[0]) {
        formData.append(fieldName, fileArray[0]);
      } else if (willUpdate) {
        shipmentData[fieldName] = null;
      }
    }

    formData.append("data", JSON.stringify(shipmentData));

    try {
      setLoading(true);

      let response;

      if (willUpdate) {
        response = await CrudService.updateShipment(formData, shipmentId);
      } else {
        response = await CrudService.createShipment(formData);

        const createdId =
            response?.id ||
            response?.data?.id ||
            response?.data?.data?.id ||
            response?.data?._id ||
            response?.data?.data?._id;

        setIsCloneMode(false);
        setIsEditing(true);

        if (createdId) {
          setActiveShipmentId(createdId);

          navigate(
              `/shipping-order/create-shipment/details?id=${createdId}`,
              { replace: true }
          );
        }
      }

      if (buttonType === "shipment") {
        setSuccessMessage(
            willUpdate
                ? "Update operation was successfully completed."
                : "Create operation was successfully completed."
        );
        setErrorMessage("");
        window.scrollTo({ top: 0, behavior: "smooth" });

        if (shouldPrintCmr) {
          // One CMR per truck, each with its own plate and the cargo it carries, shown in
          // the print preview; the page stays open while it is in use.
          setCmrDocuments(
              cmrPayloadsForTrucks({ ...shipmentData, shipmentNo }).map((data, i) => ({
                label: `Truck ${i + 1}${data.plateContainerNumber ? ` · ${data.plateContainerNumber}` : ""}`,
                data,
              }))
          );
          return;
        }

        setTimeout(() => {
          navigate("/shipping-order/shipment-tables/details");
        }, 3000);

        return;
      } else {
        setSnackbar({
          open: true,
          severity: "success",
          message: willUpdate
              ? "Location history update was successfully completed."
              : "Location history create was successfully completed.",
        });

        window.scrollTo({ top: 0, behavior: "smooth" });
        setLocationHistory(shipmentData.locationHistory);
        setPickupLocation({
          ...initialAddressState,
          ...shipmentData.pickupLocation,
        });
        setDeliveryLocation({
          ...initialAddressState,
          ...shipmentData.deliveryLocation,
        });
        setProofOfDelivery(shipmentData.proofOfDelivery);
        setProofOfDeliveryTime(shipmentData.proofOfDeliveryTime);
        setRefreshLocationHistory((prev) => !prev);
      }
    } catch (err) {
      console.error("İstek başarısız oldu: ", err);

      setSnackbar({
        open: true,
        severity: "error",
        message: "Request failed. Please try again.",
      });

      window.scrollTo({ top: 0, behavior: "smooth" });
    } finally {
      setLoading(false);
    }
  };
  const removeCargoDetail = (index) => {
    const updatedCargoDetails = [...cargoDetails];
    updatedCargoDetails.splice(index, 1); // Belirli index'teki öğeyi kaldır
    setCargoDetails(updatedCargoDetails); // cargoDetails'i güncelle
  };

  const emptyCargoRow = {
    commodity: "",
    hsCode: "",
    selectedPackingType: "",
    unitQuantity: "",
    grossWeight: "",
    notStackable: true,
    stackingFactor: 2,
    cbm: 0,
    ldm: 0,
    chargeableWeight: 0,
    description: "",
    operationType: "road",
    incoterm: "",
    goodsOriginCountry: "",
  };

  const handleCloneShipment = async () => {
    try {
      setLoading(true);

      // Same trucks as on a truck duplicate: vehicle, documents and load start empty.
      const clonedTrucks = trucks.map(duplicateTruck);

      const clonedPayload = {
        ...buildShipmentPayload(),
        ...trucksForPayload(clonedTrucks),

        // yeni kayıtta eski dosya/id taşınmasın
        cargoDetails: [normalizeCargo(emptyCargoRow, clonedTrucks)],
        locationHistory: [],
      };

      const formData = new FormData();
      formData.append("data", JSON.stringify(clonedPayload));

      const response = await CrudService.createShipment(formData);

      const createdId =
          response?.data?.data?.id ||
          response?.data?.id ||
          response?.data?.data?._id ||
          response?.data?._id;

      if (!createdId) {
        throw new Error("Created shipment id not found");
      }

      setIsCloneMode(false);
      setIsEditing(true);
      setActiveShipmentId(createdId);

      setLinkedRmbl(null);
      setSuccessMessage("Shipment cloned and new shipment created successfully.");
      setErrorMessage("");

      navigate(`/shipping-order/create-shipment/details?id=${createdId}`, {
        replace: true,
      });
    } catch (error) {
      console.error("Clone shipment error:", error);
      setErrorMessage("Clone shipment failed.");
    } finally {
      setLoading(false);
    }
  };
  const handleOpenConnectRmbl = () => {
    if (linkedRmbl) {
      setErrorMessage(`This shipment is already connected to ${linkedRmblLabel}.`);
      return;
    }
    setConnectRmblOpen(true);
  };

  const handleNewRmbl = async () => {
    const validShipmentId = activeShipmentId || shipmentId;

    if (!validShipmentId) {
      setErrorMessage("Please create/save this shipment before connecting to RMBL.");
      setConnectRmblOpen(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const shipmentPayload = buildShipmentPayload();

    const currentShipment = {
      id: validShipmentId,
      attributes: {
        ...shipmentPayload,
        id: validShipmentId,
        _id: validShipmentId,
        shipmentNo,
        cargoDetails,
        shipper,
        consignee,
        pickupLocation,
        deliveryLocation,
      },
    };

    navigate("/shipping-order/connect-mbl", {
      state: {
        selectedShipments: [currentShipment],
      },
    });
  };
  const handleLoadExistingRmbls = async () => {
    try {
      setRmblLoading(true);

      const res = await CrudService.getMBLs();

      const list = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res?.data?.data)
              ? res.data.data
              : [];

      setExistingRmbls(list);
    } catch (error) {
      console.error("getMBLs error:", error);
      setExistingRmbls([]);
    } finally {
      setRmblLoading(false);
    }
  };

  const handleSelectExistingRmbl = async (rmblId) => {
    try {
      const validShipmentId = activeShipmentId || shipmentId;

      if (!validShipmentId) {
        setErrorMessage("Please save the shipment before connecting to an existing RMBL.");
        return;
      }

      setRmblLoading(true);

      const selectedRmbl = existingRmbls.find(
          (item) => String(item.id) === String(rmblId)
      );

      if (!selectedRmbl) {
        setErrorMessage("Selected RMBL could not be found.");
        return;
      }

      const attr = selectedRmbl.attributes || {};
      const currentShipments = attr.shipments || [];

      // The saved entry's own `id` is the shipment id; its attributes snapshot may have
      // none (RMBLs opened with "New RMBL"), which let the same shipment be added twice.
      const alreadyConnected = currentShipments.some((item) =>
          [item?.id, item?._id, item?.attributes?.id, item?.attributes?._id].some(
              (value) => value && String(value) === String(shipmentId)
          )
      );

      if (alreadyConnected) {
        setSuccessMessage("This shipment is already connected to selected RMBL.");
        setConnectRmblOpen(false);
        return;
      }

      const newShipment = {
        id: shipmentId,
        attributes: {
          id: shipmentId,
          _id: shipmentId,
          shipmentNo,
          customer: selectedCustomer?.name || "",
          cargoDetails: normalizeCargoList(cargoDetails, trucks),
          ...trucksForPayload(trucks),
          pickupLocation,
          deliveryLocation,
          pickupDate,
          pickupTime,
          estimatedDeliveryDate,
          estimatedDeliveryTime,
          sellingRate,
          sellingRateCurrency,
          buyingRate,
          buyingRateCurrency,
          pickupRate,
          pickupRateCurrency,
          deliveryRate,
          deliveryRateCurrency,
          exportCustomsRate,
          exportCustomsRateCurrency,
          importCustomsRate,
          importCustomsRateCurrency,
          roadTransportType: selectedRoadTransportSubOption?.label || "",
          totals: calculateTotals(),
          shipper,
          consignee,
        },
      };

      const payload = {
        ...attr,
        shipments: [...currentShipments, newShipment],
      };

      const formData = new FormData();
      formData.append("data", JSON.stringify(payload));

      await CrudService.updateMBL(formData, rmblId);

      setConnectRmblOpen(false);
      setSuccessMessage("Shipment connected to existing RMBL successfully.");

      navigate(`/shipping-order/connect-mbl?id=${rmblId}`);
    } catch (error) {
      console.error("Connect existing RMBL error:", error);
      setErrorMessage("Shipment could not be connected to selected RMBL.");
    } finally {
      setRmblLoading(false);
    }
  };

  const renderPackingTypeSelect = (label, options, value, onChange, { required = false, tooltip = "" } = {}) => (
      <TextField
          select
          label={label}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          fullWidth
          variant="outlined"
          InputLabelProps={{
            shrink: true,
            component: required
                ? RequiredLabelWithTooltip({
                  label,
                  tooltip,
                })
                : undefined,
          }}
      >
        {options.map((option) => (
            <MenuItem key={option.label} value={option.label}>
              {option.label}
            </MenuItem>
        ))}
      </TextField>
  );


  useEffect(() => {
    setWeek(calculateWeekNumber());
  }, [pickupDate]);

  useEffect(() => {
    setTransitTime(calculateTransitTime); // Update the state directly
  }, [pickupDate, estimatedDeliveryDate]);

  useEffect(() => {
    // Eğer shipmentData ve carbonFootprint varsa plannedRouteCountries'yi günceller
    if (shipmentData && shipmentData.carbonFootprint) {
      setSelectedCountries(
        shipmentData.carbonFootprint.plannedRouteCountries || [],
      );
    }
  }, [shipmentData]); // shipmentData değiştiğinde çalışır


  // useEffect ile quoteNo verilerini çekiyoruz
  useEffect(() => {
    const loadQuoteNumbers = async () => {
      try {
        const response = await CrudService.getQuotingTools();
        const quoteNumbers = response.data.map((item) => ({
          label: item.attributes.quoteNo, // Dropdown'da görünen metin
          sallingRate: item.attributes.sallingRate, // Ek bilgi
          currency: item.attributes.currency, // Ek bilgi
        }));
        setQuoteNoList(quoteNumbers); // Tüm bilgileri kaydet
      } catch (error) {
        console.error("Error fetching quote numbers:", error);
      }
    };

    loadQuoteNumbers();
  }, []);


  // QuoteNo seçimi yapıldığında ilgili verileri doldur
  useEffect(() => {
    if (selectedQuoteNo) {
      const selectedQuote = quoteDetails.find((quote) => quote.quoteNo === selectedQuoteNo);
      if (selectedQuote) {
        setSallingRate(selectedQuote.sallingRate || ""); // Eğer boşsa 0
        setCurrency(selectedQuote.currency || ""); // Eğer boşsa ""
      }
    }
  }, [selectedQuoteNo]); // Seçim değiştikçe tetiklenir

  const handleQuoteNoChange = (newValue) => {
    setSelectedQuoteNo(newValue); // Seçilen quoteNo'yu güncelle
    if (newValue) {
      setSallingRate(newValue.sallingRate || ""); // Seçili öğeden sallingRate al
      setCurrency(newValue.currency || ""); // Seçili öğeden currency al
    } else {
      setSallingRate(""); // Hiçbir şey seçilmezse sıfırla
      setCurrency("");
    }
  };

  useEffect(() => {
    if (selectedCustomer) {
      setBillTo(selectedCustomer.name || ""); // Müşteri adı "Bill To" alanına aktarılır
    }
  }, [selectedCustomer]); // selectedCustomer değiştiğinde çalışır

  const handleSwitchChange = () => {
    setIsADR(!isADR); // ADR/DG anahtarını değiştir
    if (isADR) {
      setImco(null);
    }
  };

  const handleIMCOChange = (event, newValue) => {setImco(newValue ? newValue.label : null); };

  useEffect(() => {
    const fetchServiceProviders = async () => {
      try {
        const response = await CrudService.getServiceProviders();
        const options = response.data.map(
          (serviceProvider) => serviceProvider.attributes?.name || "Unnamed Service Provider"
        );

        setServiceProviders(options);
      } catch (error) {
        console.error("Service Provider verileri alınırken hata oluştu:", error);
      }
    };

    fetchServiceProviders();
  }, []);



  const TITLE_SX = {
    fontWeight: "bold",
    lineHeight: 1.15,
    height: 48,
    mb: 1,
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
  };

  const DROPZONE_WRAPPER_SX = {
    width: "100%",
    maxWidth: "90px",
    height: "150px",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const DZ_STYLE = {
    height: "80px",
    minHeight: "80px",
    maxHeight: "80px",
    fontSize: "8px",
    overflow: "hidden"
  };
  const normalizeTextInput = (value = "") => {
    const map = {ç: "c", ğ: "g", ı: "i", ö: "o", ş: "s", ü: "u", Ç: "C", Ğ: "G", İ: "I", Ö: "O", Ş: "S", Ü: "U",};
    return value
        .split("")
        .map((char) => map[char] || char)
        .join("")
        .toUpperCase();
  };

  useEffect(() => {
    if (!shipmentData || countryOptions.length === 0) return;
    const foundPickupCountry = countryOptions.find(
        (option) =>
            option.label === shipmentData.pickupLocation?.country ||
            option.code === shipmentData.pickupLocation?.country
    );
    const foundDeliveryCountry = countryOptions.find(
        (option) =>
            option.label === shipmentData.deliveryLocation?.country ||
            option.code === shipmentData.deliveryLocation?.country
    );
    const foundExportCountry = countryOptions.find(
        (option) =>
            option.label === shipmentData.exportLocation?.country ||
            option.code === shipmentData.exportLocation?.country
    );
    setSelectedCountry(foundPickupCountry || null);
    setSelectedDeliveryCountry(foundDeliveryCountry || null);
    setSelectedExportCountry(foundExportCountry || null);
  }, [shipmentData, countryOptions]);

  useEffect(() => {
    if (location.state?.mblCustomer) {
      const mblName = location.state.mblCustomer;

      const matchedCustomer = customerOptions.find(
          (opt) =>
              opt.name?.trim().toLowerCase() === mblName.trim().toLowerCase()
      );
      setSelectedCustomer(matchedCustomer || { name: mblName });
    }
  }, [location.state, customerOptions]);

  const inputStyle = {
    "& .MuiInputBase-root": { height: 40 },
    "& .MuiOutlinedInput-input": { padding: "0 14px" },
    "& .MuiInputLabel-root": { fontSize: 14 },
  };

  const COMMON_INPUT_SX = {
    "& .MuiOutlinedInput-root": {
      height: 40,
    },
    "& .MuiInputBase-input": {
      padding: "8.5px 14px",
    },
  };

  const PRICING_INPUT_SX = {
    "& .MuiOutlinedInput-root": {
      height: 60,
      minHeight: 60,
      display: "flex",
      alignItems: "center",
    },
    "& .MuiInputBase-input": {
      height: "60px",
      boxSizing: "border-box",
      padding: "0 14px",
      display: "flex",
      alignItems: "center",
    },
    "& .MuiSelect-select": {
      height: "60px",
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      padding: "0 14px !important",
    },
  };

  return (
      <DashboardLayout>
        <DashboardNavbar/>
        <MDBox mb={1}>
          <Grid container justifyContent="center">
            <Grid item xs={12} lg={12}>
              <MDBox mb={2} textAlign="center">
                <MDBox mb={1} mt={2}>
                  {successMessage && (
                      <Alert
                          severity="success"
                          variant="filled"
                          onClose={() => setSuccessMessage("")}
                          style={{
                            backgroundColor: successMessage ? "#ECFDF3" : "transparent",
                            color: successMessage ? "#027A48" : "transparent",
                            border: successMessage ? "1px solid #ABEFC6" : "none",
                            fontWeight: 600,
                            padding: "10px",
                            textAlign: "center",
                            marginBottom: "10px",
                            borderRadius: "5px",
                            visibility: successMessage ? "visible" : "hidden",
                          }}
                      >
                        {successMessage}
                      </Alert>
                  )}

                  {errorMessage && (
                      <Alert
                          severity="error"
                          variant="filled"
                          onClose={() => setErrorMessage("")}
                          sx={{width: "100%", mt: 2}}
                      >
                        {errorMessage}
                      </Alert>
                  )}
                  <MDTypography variant="h3" fontWeight="bold">
                    {isEditing
                        ? " Edit Shipment Details"
                        : " Add Shipment Details"}
                  </MDTypography>

                </MDBox>
                <MDTypography variant="h5" fontWeight="regular" color="secondary">
                  This information will describe more about the shipment.
                </MDTypography>
                {notificationsShipmentId && (
                  <MDBox display="flex" justifyContent="center">
                    <NotificationsLauncher
                      shipmentId={notificationsShipmentId}
                      mode="ROAD"
                      refreshKey={notificationsOpen}
                      onOpen={() => setNotificationsOpen(true)}
                    />
                  </MDBox>
                )}
                <Drawer
                  anchor="right"
                  open={notificationsOpen && !!notificationsShipmentId}
                  onClose={() => setNotificationsOpen(false)}
                  PaperProps={{ sx: { width: { xs: "100%", md: "min(1200px, 92vw)" }, p: 3, textAlign: "left" } }}
                >
                  {notificationsOpen && notificationsShipmentId && (
                    <ShipmentNotifications shipmentId={notificationsShipmentId} mode="ROAD" />
                  )}
                </Drawer>
                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={5000}
                    onClose={() => setSnackbar({...snackbar, open: false})}
                    anchorOrigin={{vertical: "top", horizontal: "center"}}
                >
                  <Alert
                      severity={snackbar.severity}
                      onClose={() => setSnackbar({...snackbar, open: false})}
                      sx={{width: "100%"}}
                  >
                    {snackbar.message}
                  </Alert>
                </Snackbar>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>

        {linkedRmbl && (
            <MDBox mb={2}>
              <MDBox
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                  flexWrap="wrap"
                  gap={2}
                  sx={{
                    p: 2,
                    borderRadius: 3,
                    background: "linear-gradient(135deg, #EEF4FF 0%, #E0EAFF 100%)",
                    border: "1px solid #B6CCF5",
                  }}
              >
                <MDBox display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
                  <LinkIcon sx={{ color: "#1d4ed8" }} />
                  <MDTypography variant="button" fontWeight="bold" sx={{ color: "#1e3a8a" }}>
                    Connected to {linkedRmblLabel}
                  </MDTypography>
                  {linkedRmbl.plate && (
                      <Chip size="small" label={`Plate ${linkedRmbl.plate}`} sx={linkedMasterChipSx} />
                  )}
                  {linkedRmbl.cmrNumber && (
                      <Chip size="small" label={`CMR ${linkedRmbl.cmrNumber}`} sx={linkedMasterChipSx} />
                  )}
                </MDBox>
                <Button
                    variant="outlined"
                    size="small"
                    endIcon={<OpenInNewIcon />}
                    onClick={() => navigate(`/shipping-order/connect-mbl?id=${linkedRmbl.id}`)}
                    sx={{ color: "#1d4ed8 !important", borderColor: "#1d4ed8" }}
                >
                  Open RMBL
                </Button>
              </MDBox>
            </MDBox>
        )}

        {readOnlyMode && (
            <MDBox mb={2}>
              <Grid container justifyContent="center">
                <Grid item xs={12} lg={12}>
                  <MDBox
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      flexWrap="wrap"
                      gap={2}
                      sx={{
                        p: 2,
                        borderRadius: "10px",
                        background: "#FFF8E1",
                        border: "1px solid #FFD54F",
                      }}
                  >
                    <MDBox display="flex" alignItems="center" gap={1.5}>
                      <LockOutlinedIcon sx={{ color: "#B8860B" }} />
                      <MDTypography variant="button" fontWeight="bold" sx={{ color: "#7A5B00" }}>
                        This shipment is in read-only view. Click Edit to make changes.
                      </MDTypography>
                    </MDBox>
                    <Button
                        variant="contained"
                        startIcon={<EditIcon />}
                        onClick={() => setReadOnlyMode(false)}
                        style={{ backgroundColor: "#B8860B", color: "#FFFFFF" }}
                    >
                      Edit
                    </Button>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
        )}

        {shipmentId && (
            <MDBox mb={2} display="flex" justifyContent="flex-end" gap={1} flexWrap="wrap">
              {/* The form's own Print CMR button sits in the read-only fieldset and cannot be
                  clicked while viewing. It saves the shipment before printing, as that one does. */}
              {readOnlyMode && (
                  <Button
                      variant="contained"
                      onClick={(e) => submitHandler(e, "shipment", true)}
                      disabled={loading || !isRequiredFieldsFilled()}
                      sx={{
                        backgroundColor: "#1976d2",
                        color: "#fff",
                        "&:hover": { backgroundColor: "#1565c0" },
                      }}
                  >
                    Print CMR
                  </Button>
              )}
              <FinanceDetailsButton onClick={() => setFinanceModalOpen(true)} />
            </MDBox>
        )}

        <CmrPrintDialog
            open={Boolean(cmrDocuments)}
            documents={cmrDocuments}
            onClose={() => setCmrDocuments(null)}
        />

        <ShipmentFinanceModal
            open={financeModalOpen}
            onClose={() => setFinanceModalOpen(false)}
            shipmentId={shipmentId}
            shipmentNo={shipmentNo}
            sourceType="road"
        />

        <fieldset
            disabled={readOnlyMode}
            style={{
                border: "none",
                padding: 0,
                margin: 0,
                opacity: readOnlyMode ? 0.65 : 1,
                // Belt-and-suspenders: fieldset[disabled] only auto-locks
                // real form controls (input/select/textarea/button). Any
                // custom div-based widget in this form (drag-drop zones,
                // custom pickers) would otherwise stay clickable, so also
                // cut off all pointer interaction while read-only.
                pointerEvents: readOnlyMode ? "none" : "auto",
                transition: "opacity .15s ease",
            }}
        >
        <MDBox mb={12}
               sx={{
                 p: 3,
                 borderRadius: "10px",
                 bgcolor: "background.paper",
                 boxShadow: "none",
               }}>
          <Grid container justifyContent="center">
            <Grid item xs={12} lg={12}>
              <MDBox>
                <MDBox mt={3}>
                  <Grid container spacing={3} alignItems="center" justifyContent="space-between">
                    <Grid item xs={12} sm={6}>
                      <MDTypography variant="h6" component="div">
                        Shipment Details
                        <br/>
                        {shipmentNo ? ` Shipment No: RHFL ${shipmentNo}` : ``}
                      </MDTypography>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={6}
                        sx={{display: "flex", justifyContent: {xs: "flex-start", sm: "flex-end"}}}
                    >
                      <Button
                          variant="contained"
                          onClick={(e) => submitHandler(e, "shipment", true)}
                          disabled={loading || !isRequiredFieldsFilled()}
                          sx={{
                            backgroundColor: "#1976d2",
                            color: "#fff",
                            "&:hover": {
                              backgroundColor: "#1565c0",
                            },
                            "&.Mui-disabled": {
                              backgroundColor: "#90caf9",
                              color: "#ffffff",
                              opacity: 0.7,
                            },
                          }}
                      >
                        Print CMR
                      </Button>
                    </Grid>
                  </Grid>
                </MDBox> <MDBox mt={3}>
                <Grid container spacing={3}>
                  {/* Select Customer */}
                  <Grid item xs={12} sm={4}>
                    <Autocomplete
                        value={selectedCustomer}
                        inputValue={inputValue}
                        open={open}
                        onOpen={() => setOpen(true)}
                        onClose={() => setOpen(false)}
                        options={[NEW_PARTY_OPTION, ...customerOptions]}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(opt, val) =>
                            String(opt?.id) === String(val?.id)
                        }
                        onChange={(event, newValue) => {
                          if (newValue?.type === "new") {
                            setCustomerModalTarget("customer");
                            setCustomerModalOpen(true);
                            setOpen(false);
                            return;
                          }

                          setSelectedCustomer(newValue);
                          setInputValue(newValue?.name || "");
                          setOpen(false);
                        }}
                        onInputChange={(event, newInputValue, reason) => {
                          setInputValue(newInputValue);

                          if (reason === "input" || reason === "clear") {
                            setOpen(newInputValue.trim().length > 0);
                          }

                          if (reason === "clear" || newInputValue.trim().length === 0) {
                            setSelectedCustomer(null);
                          }
                        }}
                        renderOption={({ key: optionKey, ...props }, option) => (
                            <li {...props} key={`${option.type || "customer"}-${option.id}`}>
                              {option.type === "new" ? (
                                  <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                              ) : (
                                  <>
                                    {option.name}
                                    <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
                                      (Customer)
                                    </span>
                                  </>
                              )}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={isEditing ? "Selected Customer" : "Search Customer"}
                                variant="outlined"
                                fullWidth
                                required
                                sx={inputStyle}
                                error={fieldErrors.customer}
                                helperText={fieldErrors.customer ? `${isEditing ? "Selected Customer" : "Search Customer"} is required` : ""}
                                InputLabelProps={{
                                  shrink: true,
                                  component: RequiredLabelWithTooltip({
                                    label: isEditing ? "  Selected Customer" : "  Search Customer",
                                    tooltip: "Customer selection required",
                                    dot: true,
                                  }),
                                }}
                                InputProps={{
                                  ...params.InputProps,
                                }}
                            />
                        )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Autocomplete
                        value={selectedRoadTransportSubOption}
                        onChange={(event, newValue) =>
                            setSelectedRoadTransportSubOption(newValue)
                        }
                        options={roadTransportSubOptions}
                        getOptionLabel={(option) => option.label}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Road Transport Mode"
                                placeholder="Road Transport Mode"
                                fullWidth
                                required
                                variant="outlined"
                                sx={inputStyle}
                                error={fieldErrors.roadTransport}
                                helperText={fieldErrors.roadTransport ? "Road Transport Mode is required" : ""}
                                InputLabelProps={{
                                  shrink: true,
                                  component: RequiredLabelWithTooltip({
                                    label: "Road Transport Mode",
                                    tooltip: "The selection of the road transport mode is required.",
                                    dot: true,
                                  }),
                                }}
                            />
                        )}
                    />
                  </Grid>


                  <Grid item xs={12} sm={3}>
                    <Autocomplete
                        options={[NEW_PARTY_OPTION, ...shipperConsigneeOptions]}
                        value={findOptionByName(shipper)}
                        onChange={(_e, newValue) => {
                          if (newValue?.type === "new") {
                            setCustomerModalTarget("shipper");
                            setCustomerModalOpen(true);
                            return;
                          }

                          setShipper(newValue?.name || "");
                        }}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                        renderOption={({ key: optionKey, ...props }, option) => (
                            <li {...props} key={option.id}>
                              {option.type === "new" ? (
                                  <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                              ) : (
                                  <>
                                    {option.name}
                                    <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
              {option.type === "customer"
                  ? "(Customer)"
                  : option.type === "agent"
                      ? "(Global Agent)"
                      : "(Company)"}
            </span>
                                  </>
                              )}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField {...params} label="Shipper" fullWidth InputLabelProps={{ shrink: true }} />
                        )}
                    />
                  </Grid>

                  <Grid item xs={12} sm={3}>
                    <Autocomplete
                        options={[NEW_PARTY_OPTION, ...shipperConsigneeOptions]}
                        value={findOptionByName(consignee)}
                        onChange={(_e, newValue) => {
                          if (newValue?.type === "new") {
                            setCustomerModalTarget("consignee");
                            setCustomerModalOpen(true);
                            return;
                          }

                          setConsignee(newValue?.name || "");
                        }}
                        getOptionLabel={(option) => option?.name || ""}
                        isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                        renderOption={({ key: optionKey, ...props }, option) => (
                            <li {...props} key={option.id}>
                              {option.type === "new" ? (
                                  <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                              ) : (
                                  <>
                                    {option.name}
                                    <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
              {option.type === "customer"
                  ? "(Customer)"
                  : option.type === "agent"
                      ? "(Global Agent)"
                      : "(Company)"}
            </span>
                                  </>
                              )}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField {...params} label="Consignee" fullWidth InputLabelProps={{ shrink: true }} />
                        )}
                    />
                  </Grid>
                </Grid>
              </MDBox>
                <MDBox mt={3}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={2}>
                      <Autocomplete
                          options={[NEW_PARTY_OPTION, SAME_AS_CONSIGNEE_OPTION, ...shipperConsigneeOptions]}
                          value={findOptionByName(notify)}
                          onChange={(_e, newValue) => {
                            if (newValue?.type === "new") {
                              setCustomerModalTarget("notify");
                              setCustomerModalOpen(true);
                              return;
                            }

                            if (newValue?.type === "sameAsConsignee") {
                              setNotify(consignee || "");
                              return;
                            }

                            setNotify(newValue?.name || "");
                          }}
                          getOptionLabel={(option) => option?.name || ""}
                          isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                          renderOption={({ key: optionKey, ...props }, option) => (
                              <li {...props} key={option.id}>
                                {option.type === "new" ? (
                                    <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                                ) : option.type === "sameAsConsignee" ? (
                                    <strong style={{ color: "#2e7d32" }}>Same as Consignee</strong>
                                ) : (
                                    <>
                                      {option.name}
                                      <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
              {option.type === "customer"
                  ? "(Customer)"
                  : option.type === "agent"
                      ? "(Global Agent)"
                      : "(Company)"}
            </span>
                                    </>
                                )}
                              </li>
                          )}
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Notify"
                                  placeholder="Select Notify Party"
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                              />
                          )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={2}>
                      <Autocomplete
                          freeSolo
                          options={[NEW_PARTY_OPTION, ...shipperConsigneeOptions]}
                          filterOptions={filterManufacturerOptions}
                          inputValue={manufacturer || ""}
                          onInputChange={(_e, value, reason) => {
                            if (reason === "input" || reason === "clear") setManufacturer(value);
                          }}
                          onChange={(_e, newValue) => {
                            if (newValue?.type === "new") {
                              setCustomerModalTarget("manufacturer");
                              setCustomerModalOpen(true);
                              return;
                            }

                            if (newValue && typeof newValue === "object") {
                              setManufacturer(newValue.name || "");
                            }
                          }}
                          getOptionLabel={(option) =>
                              typeof option === "string" ? option : option?.name || ""
                          }
                          renderOption={({ key: optionKey, ...props }, option) => (
                              <li {...props} key={option.id}>
                                {option.type === "new" ? (
                                    <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                                ) : (
                                    <>
                                      {option.name}
                                      <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
                                        {option.type === "customer"
                                            ? "(Customer)"
                                            : option.type === "agent"
                                                ? "(Global Agent)"
                                                : "(Company)"}
                                      </span>
                                    </>
                                )}
                              </li>
                          )}
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Manufacturer"
                                  placeholder="Enter Manufacturer"
                                  fullWidth
                                  variant="outlined"
                                  sx={inputStyle}
                                  InputLabelProps={{shrink: true}}
                              />
                          )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={2}>
                      <TextField
                          label="Bill To"
                          placeholder="Enter Bill To"
                          value={billTo}
                          onChange={(e) => setBillTo(e.target.value)}
                          fullWidth
                          variant="outlined"
                          sx={inputStyle}
                          InputLabelProps={{shrink: true}}
                      />
                    </Grid>

                    {/* Truck Type is entered per truck in the Trucks section. */}
                    {/* Sales Representative */}
                    <Grid item xs={12} sm={2}>
                      <Autocomplete
                          multiple
                          options={salesRepOptions}
                          getOptionLabel={(option) => option.label}
                          value={salesRep}
                          onChange={(event, newValues) => setSalesRep(newValues)}
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Sales Rep"
                                  placeholder="Select Sales Rep"
                                  fullWidth
                                  variant="outlined"
                                  sx={inputStyle}
                                  InputLabelProps={{shrink: true}}
                              />
                          )}
                      />
                    </Grid>

                    {/* Quote No */}
                    <Grid item xs={12} sm={2}>
                      {renderCountryAutocomplete(
                          "Quote No",
                          quoteNoList,
                          selectedQuoteNo,
                          handleQuoteNoChange
                      )}
                    </Grid>
                  </Grid>
                </MDBox>
                {/* Pickup Address */}
                <MDBox mt={3}>
                  <MDTypography variant="h6">Pickup Location</MDTypography>
                </MDBox>

                {/* PICKUP TYPE */}
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6} display="flex" alignItems="center">
                    <MDTypography variant="h6" sx={{mr: 1}}>
                      Distribution Rate
                    </MDTypography>

                    <ColoredSwitch
                        checked={pickupLocation?.pickupType === "Direct Pickup"}
                        onChange={(e) =>
                            handleStateChange(
                                setPickupLocation,
                                "pickupType",
                                e.target.checked ? "Direct Pickup" : "Distribution Rate"
                            )
                        }
                        ownerState={{checked: pickupLocation?.pickupType === "Direct Pickup"}}
                    />

                    <MDTypography variant="h6" sx={{ml: 1}}>
                      Direct Pickup
                    </MDTypography>
                  </Grid>

                  {pickupLocation?.pickupType === "Distribution Rate" && (
                      <>
                        <Grid item xs={3}>
                          <Autocomplete
                              options={[NEW_SERVICE_PROVIDER_OPTION, ...serviceProviders]}
                              value={
                                  serviceProviders.find(
                                      (opt) =>
                                          opt?.toLowerCase() ===
                                          pickupLocation?.serviceProvider?.toLowerCase()
                                  ) || null
                              }
                              getOptionLabel={getServiceProviderOptionLabel}
                              renderOption={renderServiceProviderOption}
                              onChange={(event, newValue) => {
                                if (newValue?.type === "new") {
                                  setServiceProviderModalTarget("pickup");
                                  setServiceProviderModalOpen(true);
                                  return;
                                }

                                handleStateChange(setPickupLocation, "serviceProvider", newValue);
                              }}
                              renderInput={(params) => (
                                  <TextField
                                      {...params}
                                      label="Pick-up Service Provider"
                                      variant="outlined"
                                      fullWidth
                                  />
                              )}
                          />
                        </Grid>
                      </>
                  )}
                </Grid>

                <MDBox mt={2}>
                  <Grid container spacing={3}>
                    {/* COUNTRY */}
                    <Grid item xs={12} sm={6}>
                      <Autocomplete
                          options={countryOptions}
                          value={selectedCountry}
                          onChange={(event, newValue) => {
                            setSelectedCountry(newValue);
                            handleStateChange(setPickupLocation, "country", newValue?.label || "");
                            handleStateChange(setPickupLocation, "city", "");
                          }}
                          getOptionLabel={(option) => option.label || ""}
                          renderOption={({ key: optionKey, ...props }, option) => (
                              <li key={optionKey} {...props} style={{display: "flex", alignItems: "center"}}>
                                {option.flagUrl && (
                                    <img
                                        src={option.flagUrl}
                                        alt={option.label}
                                        width="20"
                                        height="15"
                                        style={{marginRight: 8}}
                                    />
                                )}
                                {option.label}
                              </li>
                          )}
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Pickup Country"
                                  placeholder="Select Pickup Country"
                                  variant="outlined"
                                  fullWidth
                                  InputLabelProps={{shrink: true}}
                                  sx={{"& .MuiInputBase-root": {height: 40}}}
                              />
                          )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Autocomplete
                          freeSolo
                          options={pickupCityOptions}
                          loading={pickupCityLoading}
                          value={pickupLocation.city ? {label: pickupLocation.city} : null}
                          inputValue={pickupLocation.city || ""}
                          onChange={(_, value) => {
                            const city =
                                typeof value === "string"
                                    ? value
                                    : value?.label || "";

                            handleStateChange(setPickupLocation, "city", city);
                          }}
                          onInputChange={(_, value) => {
                            handleStateChange(setPickupLocation, "city", value || "");
                          }}
                          getOptionLabel={(option) =>
                              typeof option === "string" ? option : option?.label || ""
                          }
                          isOptionEqualToValue={(option, value) =>
                              option?.label === value?.label
                          }
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Pickup City"
                                  variant="outlined"
                                  fullWidth
                                  InputLabelProps={{shrink: true}}
                                  sx={{"& .MuiInputBase-root": {height: 40}}}
                              />
                          )}
                      />
                    </Grid>
                  </Grid>
                </MDBox>

                <Grid item xs={12} mt={2}>
                  <TextField
                      type="text"
                      label="Additional Pickup Address Info"
                      placeholder="Enter additional information"
                      value={pickupLocation?.additionalInfo || ""}
                      onChange={(e) =>
                          handleStateChange(
                              setPickupLocation,
                              "additionalInfo",
                              normalizeTextInput(e.target.value)
                          )
                      }
                      fullWidth
                      variant="outlined"
                  />
                </Grid>


                <MDBox mt={3}>
                  <MDTypography variant="h6">Destination Location</MDTypography>
                </MDBox>

                {/* Delivery Type */}
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6} display="flex" alignItems="center">
                    <Typography variant="h6" mr={1}>
                      Distribution Rate
                    </Typography>
                    <ColoredSwitch
                        checked={deliveryLocation?.deliveryType === "Direct Delivery"}
                        onChange={(e) =>
                            handleStateChange(
                                setDeliveryLocation,
                                "deliveryType",
                                e.target.checked ? "Direct Delivery" : "Distribution Rate"
                            )
                        }
                        ownerState={{checked: deliveryLocation?.deliveryType === "Direct Delivery"}}
                    />
                    <Typography variant="h6" ml={1}>
                      Direct Delivery
                    </Typography>
                  </Grid>

                  {deliveryLocation?.deliveryType === "Distribution Rate" && (
                      <>
                        <Grid item xs={3}>
                          <Autocomplete
                              options={[NEW_SERVICE_PROVIDER_OPTION, ...serviceProviders]}
                              value={
                                  serviceProviders.find(
                                      (opt) =>
                                          opt?.toLowerCase() ===
                                          deliveryLocation?.serviceProvider?.toLowerCase()
                                  ) || null
                              }
                              getOptionLabel={getServiceProviderOptionLabel}
                              renderOption={renderServiceProviderOption}
                              onChange={(event, newValue) => {
                                if (newValue?.type === "new") {
                                  setServiceProviderModalTarget("delivery");
                                  setServiceProviderModalOpen(true);
                                  return;
                                }

                                handleStateChange(setDeliveryLocation, "serviceProvider", newValue);
                              }}
                              renderInput={(params) => (
                                  <TextField
                                      {...params}
                                      label="Destination Service Provider"
                                      variant="outlined"
                                      fullWidth
                                  />
                              )}
                          />
                        </Grid>
                      </>
                  )}
                </Grid>
                <MDBox mt={2}>
                  <Grid container spacing={3}>
                    {/* Destination Country */}
                    <Grid item xs={12} sm={6}>
                      <Autocomplete
                          options={countryOptions}
                          value={selectedDeliveryCountry}
                          onChange={(event, newValue) => {
                            setSelectedDeliveryCountry(newValue);

                            handleStateChange(
                                setDeliveryLocation,
                                "country",
                                newValue?.label || ""
                            );

                            // country değişince city temizle
                            handleStateChange(
                                setDeliveryLocation,
                                "city",
                                ""
                            );
                          }}
                          getOptionLabel={(option) => option?.label || ""}
                          renderOption={({ key: optionKey, ...props }, option) => (
                              <li key={optionKey} {...props} style={{display: "flex", alignItems: "center"}}>
                                {option.flagUrl && (
                                    <img
                                        src={option.flagUrl}
                                        alt={option.label}
                                        width="20"
                                        height="15"
                                        style={{marginRight: 8}}
                                    />
                                )}
                                {option.label}
                              </li>
                          )}
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Destination Country"
                                  placeholder="Select Destination Country"
                                  variant="outlined"
                                  fullWidth
                                  InputLabelProps={{shrink: true}}
                                  sx={{"& .MuiInputBase-root": {height: 40}}}
                              />
                          )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Autocomplete
                          freeSolo
                          options={deliveryCityOptions}
                          loading={deliveryCityLoading}
                          value={deliveryLocation.city ? {label: deliveryLocation.city} : null}
                          inputValue={deliveryLocation.city || ""}
                          onChange={(_, value) => {
                            const city =
                                typeof value === "string"
                                    ? value
                                    : value?.label || "";

                            handleStateChange(setDeliveryLocation, "city", city);
                          }}
                          onInputChange={(_, value) => {
                            handleStateChange(setDeliveryLocation, "city", value || "");
                          }}
                          getOptionLabel={(option) =>
                              typeof option === "string" ? option : option?.label || ""
                          }
                          isOptionEqualToValue={(option, value) =>
                              option?.label === value?.label
                          }
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Destination City"
                                  variant="outlined"
                                  fullWidth
                                  InputLabelProps={{shrink: true}}
                                  sx={{"& .MuiInputBase-root": {height: 40}}}
                              />
                          )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12}>
                      <TextField
                          label="Additional Destination Address Info"
                          placeholder="Enter additional information"
                          value={deliveryLocation?.additionalInfo || ""}
                          onChange={(e) =>
                              handleStateChange(
                                  setDeliveryLocation,
                                  "additionalInfo",
                                  normalizeTextInput(e.target.value)
                              )
                          }
                          fullWidth
                          variant="outlined"
                      />
                    </Grid>

                  </Grid>
                </MDBox>

                <TrucksSection
                    trucks={trucks}
                    setTrucks={setTrucks}
                    cargoDetails={cargoDetails}
                    setCargoDetails={setCargoDetails}
                    truckTypeOptions={truckType}
                    buyingRateCurrency={buyingRateCurrency}
                    setBuyingRateCurrency={setBuyingRateCurrency}
                    inputSx={COMMON_INPUT_SX}
                />

                <MDBox
                    mt={3}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                  <MDTypography variant="h6">Cargo Details</MDTypography>
                  <AddRowButton onClick={addCargoDetail} label="Add Cargo" />
                </MDBox>

                <MDBox mt={3}>
                  {cargoDetails.map((cargo, index) => (
                      <MDBox key={index} mt={4} p={2} borderRadius={2} border="1px solid #eee">
                        {/* DELETE */}
                        {index > 0 && (
                            <MDBox display="flex" justifyContent="flex-end" mb={2}>
                              <RemoveRowButton onClick={() => removeCargoDetail(index)} tooltip="Remove cargo" />
                            </MDBox>
                        )}

                        <Grid container spacing={3}>
                          {/* Commodity */}
                          <Grid item xs={12} sm={3}>
                            <TextField
                                label="Commodity Name"
                                value={cargo.commodity}
                                onChange={(e) =>
                                    updateCargoDetails(index, "commodity", e.target.value)
                                }
                                fullWidth
                                required
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true,
                                  component: RequiredLabelWithTooltip({
                                    label: "Commodity Name",
                                    tooltip: "Commercial name of cargo"
                                  })
                                }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <Autocomplete
                                options={countryOptions}
                                getOptionLabel={(option) => option?.label || ""}
                                value={
                                  cargo.goodsOriginCountry
                                      ? countryOptions.find((o) => o.label === cargo.goodsOriginCountry) || null
                                      : null
                                }
                                onChange={(_e, newValue) =>
                                    updateCargoDetails(index, "goodsOriginCountry", newValue?.label || "")
                                }
                                isOptionEqualToValue={(opt, val) => opt?.label === val?.label}
                                renderOption={({ key: optionKey, ...props }, option) => (
                                    <li key={optionKey} {...props} style={{display: "flex", alignItems: "center"}}>
                                      {option.flagUrl && (
                                          <img
                                              src={option.flagUrl}
                                              alt={option.label}
                                              width="20"
                                              height="15"
                                              style={{marginRight: 8}}
                                          />
                                      )}
                                      {option.label}
                                    </li>
                                )}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Goods of Origin Country"
                                        placeholder="Select Country"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{shrink: true}}
                                        sx={PRICING_INPUT_SX}
                                    />
                                )}
                            />
                          </Grid>


                          {/* HS Code */}
                          <Grid item xs={12} sm={3}>
                            <TextField
                                label="HS Code"
                                value={cargo.hsCode}
                                onChange={(e) =>
                                    updateCargoDetails(index, "hsCode", e.target.value)
                                }
                                fullWidth
                                variant="outlined"
                            />
                          </Grid>

                          {/* Packing Type */}
                          <Grid item xs={12} sm={3} sx={PRICING_INPUT_SX}>
                            {renderPackingTypeSelect(
                                "Packing Type",
                                packingOptions,
                                cargo.selectedPackingType,
                                (val) => updateCargoDetails(index, "selectedPackingType", val),
                                {required: true, tooltip: "Packing type is required"}
                            )}
                          </Grid>

                          {/* Unit Quantity */}
                          <Grid item xs={12} sm={3}>
                            <TextField
                                label={<>Unit Quantity<RequiredDot /></>}
                                type="number"
                                value={cargo.unitQuantity}
                                onChange={(e) =>
                                    updateCargoDetails(index, "unitQuantity", Number(e.target.value))
                                }
                                error={!!cargoErrors?.[index]?.unitQuantity}
                                helperText={cargoErrors?.[index]?.unitQuantity ? "Unit Quantity is required" : ""}
                                fullWidth
                                variant="outlined"
                            />
                          </Grid>

                          {/* Gross Weight */}
                          <Grid item xs={12} sm={3}>
                            <DecimalTextField
                                label={<>Gross Weight (kg)<RequiredDot /></>}
                                decimals={3}
                                value={cargo.grossWeight}
                                onChange={(e) =>
                                    updateCargoDetails(index, "grossWeight", Number(e.target.value))
                                }
                                error={!!cargoErrors?.[index]?.grossWeight}
                                helperText={cargoErrors?.[index]?.grossWeight ? "Gross Weight (kg) is required" : ""}
                                fullWidth
                                variant="outlined"
                            />
                          </Grid>

                          {/* Stackable */}
                          <Grid item xs={12} sm={3}>
                            <MDBox display="flex" alignItems="center">
                              <MDTypography variant="button">
                                {cargo.notStackable ? "Not Stackable" : "Stackable"}
                              </MDTypography>
                              <Switch
                                  checked={!cargo.notStackable}
                                  onChange={() =>
                                      updateCargoDetails(
                                          index,
                                          "notStackable",
                                          !cargo.notStackable
                                      )
                                  }
                              />
                            </MDBox>
                          </Grid>

                          {/* Stacking Factor */}
                          {!cargo.notStackable && (
                              <Grid item xs={12} sm={3}>
                                <TextField
                                    label="Stacking Factor"
                                    type="number"
                                    value={cargo.stackingFactor}
                                    onChange={(e) =>
                                        updateCargoDetails(
                                            index,
                                            "stackingFactor",
                                            Number(e.target.value)
                                        )
                                    }
                                    fullWidth
                                    variant="outlined"
                                />
                              </Grid>
                          )}

                          {/* Calculated */}
                          {[
                            ["cbm", "CBM"],
                            ["ldm", "LDM"],
                            ["chargeableWeight", "Chargeable Weight"],
                          ].map(([field, fieldLabel]) => (
                              <Grid item xs={12} sm={3} key={field}>
                                <DecimalTextField
                                    label={fieldLabel}
                                    decimals={field === "cbm" ? 4 : 3}
                                    value={cargo[field]}
                                    onChange={(e) => updateCargoDetails(index, field, Number(e.target.value))}
                                    fullWidth
                                    variant="outlined"
                                />
                              </Grid>
                          ))}

                          <Grid item xs={12} sm={3}>
                            <Autocomplete
                                options={incotermsOptions}
                                getOptionLabel={(option) => option.label}
                                value={
                                  cargo.incoterm
                                      ? incotermsOptions.find((o) => o.label === cargo.incoterm) || null
                                      : null
                                }
                                onChange={(_e, newValue) =>
                                    updateCargoDetails(index, "incoterm", newValue ? newValue.label : "")
                                }
                                isOptionEqualToValue={(opt, val) => opt.label === val.label}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Incoterm"
                                        placeholder="Select Incoterm"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{shrink: true}}
                                        sx={PRICING_INPUT_SX}
                                    />
                                )}
                            />
                          </Grid>

                        </Grid>

                        {/* Description + ADR */}
                        <Grid container spacing={3} mt={1} alignItems="center">
                          <Grid item xs={12} sm={6}>
                            <TextField
                                label="Description"
                                value={cargo.description}
                                onChange={(e) =>
                                    updateCargoDetails(index, "description", e.target.value)
                                }
                                fullWidth
                                variant="outlined"
                            />
                          </Grid>

                          <Grid item xs={12} sm={3}>
                            <FormControlLabel
                                control={
                                  <Switch
                                      checked={isADR}
                                      onChange={handleSwitchChange}
                                  />
                                }
                                label="ADR / DG"
                            />
                          </Grid>

                          {isADR && (
                              <Grid item xs={12} sm={3}>
                                <Autocomplete
                                    options={imcoOptions}
                                    value={
                                        imcoOptions.find(
                                            (opt) => opt.label === imco
                                        ) || null
                                    }
                                    onChange={handleIMCOChange}
                                    getOptionLabel={(opt) => opt.label}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="IMCO Class"
                                            variant="outlined"
                                            fullWidth
                                        />
                                    )}
                                />
                              </Grid>
                          )}
                        </Grid>

                        <CargoTruckLoads
                            cargo={cargo}
                            index={index}
                            trucks={trucks}
                            setCargoDetails={setCargoDetails}
                        />
                      </MDBox>
                  ))}
                </MDBox>

                {/* TOTALS: always for a multi-truck file, otherwise LTL as before */}
                {(loadsPerTruck || ["LTL-IMPORT", "LTL-EXPORT", "LTL-DOMESTIC", "LTL-TRANSIT"].includes(
                    selectedRoadTransportSubOption?.label
                )) && (
                    <MDBox mt={4}>
                      <MDTypography variant="h6">Total Values</MDTypography>
                      <Grid container spacing={3} mt={1}>
                        {[
                          ["Total LDM", "totalLdm"],
                          ["Total CBM", "totalCbm"],
                          ["Total Chargeable Weight", "totalChargeableWeight"]
                        ].map(([label, key]) => (
                            <Grid item xs={12} sm={3} key={key}>
                              <TextField
                                  label={label}
                                  value={calculateTotals()[key]}
                                  InputProps={{readOnly: true}}
                                  fullWidth
                                  variant="outlined"
                              />
                            </Grid>
                        ))}
                      </Grid>
                    </MDBox>
                )}


                <MDBox mt={3}>
                  <MDTypography variant="h6">Operational Details</MDTypography>
                  <Grid container alignItems="center" spacing={2} mt={1}>
                    {/* SOL: Soru + Shipper/Filenders switch alanı */}
                    <Grid item xs={12} md={6}>
                      <MDTypography variant="h6">Who is responsible for Export Customs Clearence?</MDTypography>
                      <MDBox mt={1} display="flex" alignItems="center" gap={2}>
                        <MDTypography variant="h6">Exporter</MDTypography>
                        <ColoredSwitch
                            checked={customDetail.responsibility || false}
                            onChange={(e) =>
                                handleStateChange(setCustomDetail, "responsibility", e.target.checked)
                            }
                            ownerState={{checked: customDetail.responsibility}}
                        />

                        <MDTypography variant="h6">Filenders</MDTypography>
                      </MDBox>
                    </Grid>

                    {/* SAĞ: Autocomplete (sadece Filenders seçiliyse) */}
                    <Grid item xs={12} md={6}>
                      {customDetail.responsibility && (
                          <Autocomplete
                              options={[NEW_SERVICE_PROVIDER_OPTION, ...serviceProviders]}
                              filterOptions={filterServiceProviderOptions}
                              getOptionLabel={getServiceProviderOptionLabel}
                              renderOption={renderServiceProviderOption}
                              value={customDetail.customNote || ""}
                              onChange={(_e, v) => {
                                if (v?.type === "new") {
                                  setServiceProviderModalTarget("customsExport");
                                  setServiceProviderModalOpen(true);
                                  return;
                                }

                                handleStateChange(setCustomDetail, "customNote", v || "");
                              }}
                              inputValue={customDetail.customNote || ""}
                              onInputChange={(_e, v, reason) => {
                                // picking "+ New Account" must not overwrite the field with its label
                                if (reason === "reset" && v === NEW_SERVICE_PROVIDER_OPTION.name) return;

                                handleStateChange(setCustomDetail, "customNote", v || "");
                              }}
                              freeSolo
                              renderInput={(params) => (
                                  <TextField
                                      {...params}
                                      label="Customs Brokerage Name"
                                      fullWidth
                                      variant="outlined"
                                      size="small"
                                  />
                              )}
                          />
                      )}
                    </Grid>
                  </Grid>
                </MDBox>
                <MDBox mt={3}>
                  <MDTypography variant="h6">Export Customs Office</MDTypography>
                </MDBox>
                <MDBox mt={2}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={3}>
                      <Autocomplete
                          multiple
                          options={customsOfficeOptions}
                          value={exportLocation?.additionalInfo || []}
                          onChange={(event, newValue) =>
                              setExportLocation(prev => ({
                                ...prev,
                                additionalInfo: newValue,
                              }))
                          }
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Export Exit Customs"
                                  placeholder="Select one or more"
                                  variant="outlined"
                                  fullWidth
                              />
                          )}
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      {renderCountryAutocomplete(
                          "Export Country",
                          countryOptions,
                          selectedExportCountry,
                          setSelectedExportCountry,
                          setExportLocation,
                          handleStateChange,
                          "country"
                      )}
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                          label="Export Customs Office Code"
                          value={exportLocation.officeCode || ""}
                          onChange={(e) =>
                              handleStateChange(setExportLocation, "officeCode", e.target.value)
                          }
                          fullWidth
                          variant="outlined"
                      />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      <Autocomplete
                          options={[NEW_SERVICE_PROVIDER_OPTION, ...serviceProviders]}
                          filterOptions={filterServiceProviderOptions}
                          getOptionLabel={getServiceProviderOptionLabel}
                          renderOption={renderServiceProviderOption}
                          value={exportLocation.brokerageName || ""}
                          onChange={(_e, v) => {
                            if (v?.type === "new") {
                              setServiceProviderModalTarget("exportBrokerage");
                              setServiceProviderModalOpen(true);
                              return;
                            }

                            handleStateChange(setExportLocation, "brokerageName", v || "");
                          }}
                          inputValue={exportLocation.brokerageName || ""}
                          onInputChange={(_e, v, reason) => {
                            // picking "+ New Account" must not overwrite the field with its label
                            if (reason === "reset" && v === NEW_SERVICE_PROVIDER_OPTION.name) return;

                            handleStateChange(setExportLocation, "brokerageName", v || "");
                          }}
                          freeSolo
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Export Customs Brokerage Name"
                                  fullWidth
                                  variant="outlined"
                              />
                          )}
                      />
                    </Grid>
                  </Grid>
                </MDBox>

                <Grid container spacing={2} alignItems="center" mt={2}>
                  {/* SOL */}
                  <Grid item xs={12} md={6}>
                    <MDTypography variant="h6">
                      Who is responsible for Import Customs Clearence?
                    </MDTypography>

                    <MDBox mt={1} display="flex" alignItems="center" gap={2}>
                      <MDTypography variant="h6">Importer</MDTypography>

                      <ColoredSwitch
                          checked={customDetail.responsibilityImport || false}
                          onChange={(e) =>
                              handleStateChange(
                                  setCustomDetail,
                                  "responsibilityImport",
                                  e.target.checked
                              )
                          }
                          ownerState={{checked: customDetail.responsibilityImport}}
                      />

                      <MDTypography variant="h6">Filenders</MDTypography>
                    </MDBox>
                  </Grid>

                  {/* SAĞ */}
                  <Grid item xs={12} md={6}>
                    {customDetail.responsibilityImport && (
                        <Autocomplete
                            options={[NEW_SERVICE_PROVIDER_OPTION, ...serviceProviders]}
                            filterOptions={filterServiceProviderOptions}
                            getOptionLabel={getServiceProviderOptionLabel}
                            renderOption={renderServiceProviderOption}
                            value={customDetail.customNoteImport || ""}
                            onChange={(_e, v) => {
                              if (v?.type === "new") {
                                setServiceProviderModalTarget("customsImport");
                                setServiceProviderModalOpen(true);
                                return;
                              }

                              handleStateChange(setCustomDetail, "customNoteImport", v || "");
                            }}
                            inputValue={customDetail.customNoteImport || ""}
                            onInputChange={(_e, v, reason) => {
                              // picking "+ New Account" must not overwrite the field with its label
                              if (reason === "reset" && v === NEW_SERVICE_PROVIDER_OPTION.name) return;

                              handleStateChange(setCustomDetail, "customNoteImport", v || "");
                            }}
                            freeSolo
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Customs Brokerage Name"
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                />
                            )}
                        />
                    )}
                  </Grid>
                </Grid>


                <MDBox mt={3}>
                  <MDTypography variant="h6">Import Customs Office</MDTypography>
                </MDBox>

                <MDBox mt={2}>
                  <Grid container spacing={3}>
                    {/* Import Entry Customs Info */}
                    <Grid item xs={12} sm={3}>
                      <Autocomplete
                          multiple
                          options={customsOfficeOptions}
                          value={importLocation?.additionalInfo || []}
                          onChange={(event, newValue) =>
                              setImportLocation(prev => ({
                                ...prev,
                                additionalInfo: newValue
                              }))
                          }
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Export Import Customs"
                                  placeholder="Select one or more"
                                  variant="outlined"
                                  fullWidth
                              />
                          )}
                      />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      {renderCountryAutocomplete(
                          "Import Country",
                          countryOptions,
                          selectedImportCountry,
                          setSelectedImportCountry,
                          setImportLocation,
                          handleStateChange,
                          "country"
                      )}
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      <TextField
                          type="text"
                          label="Import Customs Office Code"
                          placeholder="00"
                          value={importLocation?.officeCode || ""}
                          onChange={(e) =>
                              handleStateChange(setImportLocation, "officeCode", e.target.value)
                          }
                          variant="outlined"
                          fullWidth
                          InputLabelProps={{shrink: true}}
                      />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      <Autocomplete
                          options={[NEW_SERVICE_PROVIDER_OPTION, ...serviceProviders]}
                          filterOptions={filterServiceProviderOptions}
                          getOptionLabel={getServiceProviderOptionLabel}
                          renderOption={renderServiceProviderOption}
                          value={importLocation?.brokerageName || ""}
                          onChange={(_e, v) => {
                            if (v?.type === "new") {
                              setServiceProviderModalTarget("importBrokerage");
                              setServiceProviderModalOpen(true);
                              return;
                            }

                            handleStateChange(setImportLocation, "brokerageName", v || "");
                          }}
                          inputValue={importLocation?.brokerageName || ""}
                          onInputChange={(_e, v, reason) => {
                            // picking "+ New Account" must not overwrite the field with its label
                            if (reason === "reset" && v === NEW_SERVICE_PROVIDER_OPTION.name) return;

                            handleStateChange(setImportLocation, "brokerageName", v || "");
                          }}
                          freeSolo
                          renderInput={(params) => (
                              <TextField
                                  {...params}
                                  type="text"
                                  label="Import Customs Brokerage Name"
                                  placeholder="Select Import Customs Brokerage"
                                  fullWidth
                                  variant="outlined"
                                  InputLabelProps={{shrink: true}}
                              />
                          )}
                      />
                    </Grid>

                  </Grid>
                </MDBox>


                <MDBox mt={3}>
                  <Grid container spacing={3}>
                    {/* Country of Origin */}
                    <Grid item xs={12} sm={4}>
                      {renderCountryOfOriginAutocomplete(
                          "Country of Origin",
                          countryOptions,
                          countryOfOrigin,
                          setCountryOfOrigin
                      )}
                    </Grid>

                    {/* T1 / T2 Declaration */}
                    <Grid item xs={12} sm={4}>
                      <TextField
                          type="text"
                          label="T1 / T2 Declaration Number"
                          placeholder="00"
                          value={t1DeclarationNumber || ""}
                          onChange={(e) => setT1DeclarationNumber(e.target.value)}
                          variant="outlined"
                          fullWidth
                          InputLabelProps={{shrink: true}}
                      />
                    </Grid>

                    {/* Plate, CMR and seal numbers are entered per truck in the Trucks section. */}
                  </Grid>
                </MDBox>


                {/* ================= PRICING DETAILS ================= */}
                <MDBox mt={3}>
                  <MDTypography variant="h6">Pricing Details</MDTypography>
                </MDBox>

                <Grid container spacing={2} mt={1}>

                  {/* BUYING RATE */}
                  {customDetail?.responsibility && (
                      <>
                        <Grid item xs={3}>
                          <TextField
                              type="number"
                              label="Total Buying Rate"
                              value={buyingRate}
                              InputProps={{readOnly: true}}
                              helperText="Sum of the trucks' buying rates"
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{shrink: true}}
                              sx={PRICING_INPUT_SX}
                          />
                        </Grid>

                        <Grid item xs={3}>
                          <TextField
                              select
                              label="Currency"
                              value={buyingRateCurrency}
                              onChange={(e) => setBuyingRateCurrency(e.target.value)}
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{shrink: true}}
                              sx={PRICING_INPUT_SX}
                          >
                            {["USD", "EUR", "GBP", "TRY"].map((c) => (
                                <MenuItem key={c} value={c}>{c}</MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </>
                  )}

                  {/* PICKUP RATE */}
                  {pickupLocation?.pickupType !== "Direct Pickup" && (
                      <>
                        <Grid item xs={3}>
                          <TextField
                              type="number"
                              label="Pickup Rate"
                              placeholder="Enter Pickup Rate"
                              value={pickupRate}
                              onChange={(e) => setPickupRate(e.target.value)}
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{shrink: true}}
                              sx={PRICING_INPUT_SX}
                          />
                        </Grid>

                        <Grid item xs={3}>
                          <TextField
                              select
                              label="Currency"
                              value={pickupRateCurrency}
                              onChange={(e) => setPickupRateCurrency(e.target.value)}
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{shrink: true}}
                              sx={PRICING_INPUT_SX}
                          >
                            {["USD", "EUR", "GBP", "TRY"].map((c) => (
                                <MenuItem key={c} value={c}>{c}</MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </>
                  )}

                  {/* DELIVERY RATE */}
                  {deliveryLocation?.deliveryType !== "Direct Delivery" && (
                      <>
                        <Grid item xs={3}>
                          <TextField
                              type="number"
                              label="Delivery Rate"
                              placeholder="Enter Delivery Rate"
                              value={deliveryRate}
                              onChange={(e) => setDeliveryRate(e.target.value)}
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{shrink: true}}
                              sx={PRICING_INPUT_SX}
                          />
                        </Grid>

                        <Grid item xs={3}>
                          <TextField
                              select
                              label="Currency"
                              value={deliveryRateCurrency}
                              onChange={(e) => setDeliveryRateCurrency(e.target.value)}
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{shrink: true}}
                              sx={PRICING_INPUT_SX}
                          >
                            {["USD", "EUR", "GBP", "TRY"].map((c) => (
                                <MenuItem key={c} value={c}>{c}</MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </>
                  )}

                  {customDetail?.responsibility && (
                      <>
                        <Grid item xs={3}>
                          <TextField
                              type="number"
                              label="Export Customs Clearance Rate"
                              placeholder="Enter Export Customs Rate"
                              value={exportCustomsRate}
                              onChange={(e) => setExportCustomsRate(e.target.value)}
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{shrink: true}}
                              sx={PRICING_INPUT_SX}
                          />
                        </Grid>

                        <Grid item xs={3}>
                          <TextField
                              select
                              label="Currency"
                              value={exportCustomsRateCurrency}
                              onChange={(e) => setExportCustomsRateCurrency(e.target.value)}
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{shrink: true}}
                              sx={PRICING_INPUT_SX}
                          >
                            {["USD", "EUR", "GBP", "TRY"].map((c) => (
                                <MenuItem key={c} value={c}>{c}</MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </>
                  )}

                  {customDetail?.responsibilityImport && (
                      <>
                        <Grid item xs={3}>
                          <TextField
                              type="number"
                              label="Import Customs Clearance Rate"
                              placeholder="Enter Import Customs Rate"
                              value={importCustomsRate}
                              onChange={(e) => setImportCustomsRate(e.target.value)}
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{shrink: true}}
                              sx={PRICING_INPUT_SX}
                          />
                        </Grid>

                        <Grid item xs={3}>
                          <TextField
                              select
                              label="Currency"
                              value={importCustomsRateCurrency}
                              onChange={(e) => setImportCustomsRateCurrency(e.target.value)}
                              fullWidth
                              variant="outlined"
                              InputLabelProps={{shrink: true}}
                              sx={PRICING_INPUT_SX}
                          >
                            {["USD", "EUR", "GBP", "TRY"].map((c) => (
                                <MenuItem key={c} value={c}>{c}</MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </>
                  )}

                </Grid>

                {/* ================= SELLING RATE ================= */}
                <MDBox mt={4}>
                  <MDTypography variant="h6">Road Freight Selling Rate Details</MDTypography>
                </MDBox>

                <Grid container spacing={2} mt={1}>
                  <Grid item xs={3}>
                    <TextField
                        type="number"
                        label="Road Freight Selling Rate"
                        placeholder="Enter Selling Rate"
                        value={sellingRate}
                        onChange={(e) => setSellingRate(e.target.value)}
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{shrink: true}}
                        sx={PRICING_INPUT_SX}
                    />
                  </Grid>

                  <Grid item xs={3}>
                    <TextField
                        select
                        label="Currency"
                        value={sellingRateCurrency}
                        onChange={(e) => setSellingRateCurrency(e.target.value)}
                        fullWidth
                        variant="outlined"
                        InputLabelProps={{shrink: true}}
                        sx={PRICING_INPUT_SX}
                    >
                      {["USD", "EUR", "GBP", "TRY"].map((c) => (
                          <MenuItem key={c} value={c}>{c}</MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>


                <MDBox mt={3}>
                  <MDTypography variant="h6"> Shipment History Details</MDTypography>
                </MDBox>

                <MDBox mt={5}>
                  <Grid container spacing={3}>
                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                      {/* First Row */}
                      <Grid container spacing={3} ml={0}>
                        {/* ========== P/U ========== */}
                        <Grid item xs={6} md={2}>
                          <DatePicker
                              label="Pickup Date"
                              value={pickupDate}
                              onChange={setPickupDate}
                              format="dd/MM/yyyy"
                              slotProps={{
                                textField: {
                                  variant: "outlined",
                                  fullWidth: true,
                                  required: true,
                                  error: fieldErrors.pickupDate,
                                  helperText: fieldErrors.pickupDate ? "Pickup Date is required" : "",
                                  InputLabelProps: {
                                    shrink: true,
                                    component: RequiredLabelWithTooltip({
                                      label: "Pickup Date",
                                      tooltip: "Pickup Date",
                                      dot: true,
                                    }),
                                  },
                                  sx: COMMON_INPUT_SX,
                                },
                                actionBar: {actions: ["clear", "accept"]},
                              }}
                          />
                        </Grid>

                        <Grid item xs={1}>
                          <TextField
                              variant="outlined"
                              label="Time"
                              type="time"
                              value={pickupTime}
                              onChange={(e) => setPickupTime(e.target.value)}
                              InputLabelProps={{shrink: true}}
                              inputProps={{step: 900}}
                              placeholder="hh:mm"
                              fullWidth
                              sx={COMMON_INPUT_SX}
                          />
                        </Grid>

                        {/* ========== ETD ========== */}
                        <Grid item xs={6} md={2}>
                          <DatePicker
                              label="ETD"
                              value={estimatedDeparture}
                              onChange={setEstimatedDeparture}
                              format="dd/MM/yyyy"
                              slotProps={{
                                textField: {
                                  variant: "outlined",
                                  fullWidth: true,
                                  InputLabelProps: {
                                    shrink: true,
                                    component: RequiredLabelWithTooltip({
                                      label: "ETD",
                                      tooltip: "Estimated Time of Departure",
                                    }),
                                  },
                                  sx: COMMON_INPUT_SX,
                                },
                                actionBar: {actions: ["clear", "accept"]},
                              }}
                          />
                        </Grid>

                        <Grid item xs={1}>
                          <TextField
                              variant="outlined"
                              label="Time"
                              type="time"
                              value={estimatedDepartureTime}
                              onChange={(e) => setEstimatedDepartureTime(e.target.value)}
                              InputLabelProps={{shrink: true}}
                              inputProps={{step: 900}}
                              placeholder="hh:mm"
                              fullWidth
                              sx={COMMON_INPUT_SX}
                          />
                        </Grid>

                        {/* ========== ETA ========== */}
                        <Grid item xs={6} md={2}>
                          <DatePicker
                              label="ETA"
                              value={estimatedDeliveryDate}
                              onChange={setEstimatedDeliveryDate}
                              format="dd/MM/yyyy"
                              slotProps={{
                                textField: {
                                  variant: "outlined",
                                  fullWidth: true,
                                  InputLabelProps: {
                                    shrink: true,
                                    component: RequiredLabelWithTooltip({
                                      label: "ETA",
                                      tooltip: "Estimated Time of Arrival",
                                    }),
                                  },
                                  sx: COMMON_INPUT_SX,
                                },
                                actionBar: {actions: ["clear", "accept"]},
                              }}
                          />
                        </Grid>

                        <Grid item xs={1}>
                          <TextField
                              variant="outlined"
                              label="Time"
                              type="time"
                              value={estimatedDeliveryTime}
                              onChange={(e) => setEstimatedDeliveryTime(e.target.value)}
                              InputLabelProps={{shrink: true}}
                              inputProps={{step: 900}}
                              placeholder="hh:mm"
                              fullWidth
                              sx={COMMON_INPUT_SX}
                          />
                        </Grid>

                        {/* ========== RDL ========== */}
                        <Grid item xs={6} md={2}>
                          <DatePicker
                              label="RDL"
                              value={requestedDeliveryDate}
                              onChange={setRequestedDeliveryDate}
                              format="dd/MM/yyyy"
                              slotProps={{
                                textField: {
                                  variant: "outlined",
                                  fullWidth: true,
                                  InputLabelProps: {
                                    shrink: true,
                                    component: RequiredLabelWithTooltip({
                                      label: "RDL",
                                      tooltip: "Requested Delivery Date",
                                    }),
                                  },
                                  sx: COMMON_INPUT_SX,
                                },
                                actionBar: {actions: ["clear", "accept"]},
                              }}
                          />
                        </Grid>

                        <Grid item xs={1}>
                          <TextField
                              variant="outlined"
                              label="Time"
                              type="time"
                              value={requestedDeliveryTime}
                              onChange={(e) => setRequestedDeliveryTime(e.target.value)}
                              InputLabelProps={{shrink: true}}
                              inputProps={{step: 900}}
                              placeholder="hh:mm"
                              fullWidth
                              sx={COMMON_INPUT_SX}
                          />
                        </Grid>

                        {/* ========== ADD ========== */}
                        <Grid item xs={6} md={2}>
                          <DatePicker
                              label="ADD"
                              value={actualDelivery}
                              onChange={setActualDelivery}
                              format="dd/MM/yyyy"
                              slotProps={{
                                textField: {
                                  variant: "outlined",
                                  fullWidth: true,
                                  InputLabelProps: {
                                    shrink: true,
                                    component: RequiredLabelWithTooltip({
                                      label: "ADD",
                                      tooltip: "Actual Delivery Date",
                                    }),
                                  },
                                  sx: COMMON_INPUT_SX,
                                },
                                actionBar: {actions: ["clear", "accept"]},
                              }}
                          />
                        </Grid>

                        <Grid item xs={1}>
                          <TextField
                              variant="outlined"
                              label="Time"
                              type="time"
                              value={actualDeliveryTime}
                              onChange={(e) => setActualDeliveryTime(e.target.value)}
                              InputLabelProps={{shrink: true}}
                              inputProps={{step: 900}}
                              placeholder="hh:mm"
                              fullWidth
                              sx={COMMON_INPUT_SX}
                          />
                        </Grid>

                        <Grid item xs={6} md={2}>
                          <DatePicker
                              label="POD"
                              value={proofOfDelivery}
                              onChange={setProofOfDelivery}
                              format="dd/MM/yyyy"
                              slotProps={{
                                textField: {
                                  variant: "outlined",
                                  fullWidth: true,
                                  InputLabelProps: {
                                    shrink: true,
                                    component: RequiredLabelWithTooltip({
                                      label: "POD",
                                      tooltip: "Proof of Delivery",
                                    }),
                                  },
                                  sx: COMMON_INPUT_SX,
                                },
                                actionBar: {actions: ["clear", "accept"]},
                              }}
                          />
                        </Grid>

                        <Grid item xs={1}>
                          <TextField
                              variant="outlined"
                              label="Time"
                              type="time"
                              value={proofOfDeliveryTime}
                              onChange={(e) => setProofOfDeliveryTime(e.target.value)}
                              InputLabelProps={{shrink: true}}
                              inputProps={{step: 900}}
                              placeholder="hh:mm"
                              fullWidth
                              sx={COMMON_INPUT_SX}
                          />
                        </Grid>

                        <Grid item xs={6} md={2}>
                          <DatePicker
                              label="APT"
                              value={appointmentDate}
                              onChange={setAppointmentDate}
                              format="dd/MM/yyyy"
                              slotProps={{
                                textField: {
                                  variant: "outlined",
                                  fullWidth: true,
                                  InputLabelProps: {
                                    shrink: true,
                                    component: RequiredLabelWithTooltip({
                                      label: "APT",
                                      tooltip: "Appointment Date",
                                    }),
                                  },
                                  sx: COMMON_INPUT_SX,
                                },
                                actionBar: {actions: ["clear", "accept"]},
                              }}
                          />
                        </Grid>

                        <Grid item xs={1}>
                          <TextField
                              variant="outlined"
                              label="Time"
                              type="time"
                              value={appointmentTime}
                              onChange={(e) => setAppointmentTime(e.target.value)}
                              InputLabelProps={{shrink: true}}
                              inputProps={{step: 900}}
                              placeholder="hh:mm"
                              fullWidth
                              sx={COMMON_INPUT_SX}
                          />
                        </Grid>

                        <Grid item xs={6} md={1}>
                          <TextField
                              variant="outlined"
                              type="number"
                              label="ETT (days)"
                              value={transitTime}
                              InputProps={{readOnly: true}}
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                                component: RequiredLabelWithTooltip({
                                  label: "ETT (days)",
                                  tooltip: "Estimated Transit Time (Days)",
                                }),
                              }}
                              sx={COMMON_INPUT_SX}
                          />
                        </Grid>

                        <Grid item xs={6} md={1}>
                          <TextField
                              variant="outlined"
                              type="number"
                              label="Week"
                              value={calculateWeekNumber()}
                              InputProps={{readOnly: true}}
                              fullWidth
                              InputLabelProps={{shrink: true}}
                              sx={COMMON_INPUT_SX}
                          />
                        </Grid>
                      </Grid>

                      {/* Second Row */}
                      <Grid container spacing={3} ml={0} mt={2}>

                      </Grid>
                    </LocalizationProvider>
                  </Grid>
                </MDBox>

                <MDBox mt={4} ml={3}>
                  <MDTypography variant="h6">DOCUMENTS</MDTypography>
                </MDBox>
                <MDBox mt={8}>
                  <Grid container>
                    <Grid
                        item
                        xs={0}
                        md={1}
                        sx={{display: {xs: "none", md: "block"}}}
                    />
                    <Grid item xs={12} md={12}>
                      <Grid container spacing={2} alignItems="flex-start">

                        {/* Export Declaration */}
                        <Grid item xs={12} sm={6} md={1}>
                          <MDBox display="flex" flexDirection="column" alignItems="center">
                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                              Export Declaration
                            </MDTypography>
                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                              <MDDropzone
                                  options={{
                                    addRemoveLinks: true,
                                    maxFilesize: 10000,
                                    maxFiles: 1,
                                    acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                    timeout: 0
                                  }}
                                  onChange={(files) => setExportDeclaration(files)}
                                  style={DZ_STYLE}
                              />
                            </MDBox>
                            <UploadedFilePreview
                                file={exportDeclaration}
                                layout="stack"
                                onRemove={() => setExportDeclaration(null)}
                            />
                          </MDBox>
                        </Grid>

                        {/* Import Declaration */}
                        <Grid item xs={12} sm={6} md={1}>
                          <MDBox display="flex" flexDirection="column" alignItems="center">
                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                              Import Declaration
                            </MDTypography>
                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                              <MDDropzone
                                  options={{
                                    addRemoveLinks: true,
                                    maxFilesize: 10000, // MB
                                    maxFiles: 1,
                                    acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                    timeout: 0
                                  }}
                                  onChange={(files) => setImportDeclaration(files)}
                                  style={DZ_STYLE}
                              />
                            </MDBox>
                            <UploadedFilePreview
                                file={importDeclaration}
                                layout="stack"
                                onRemove={() => setImportDeclaration([])}
                            />
                          </MDBox>
                        </Grid>

                        {/* ATR */}
                        <Grid item xs={12} sm={6} md={1}>
                          <MDBox display="flex" flexDirection="column" alignItems="center">
                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                              ATR
                            </MDTypography>
                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                              <MDDropzone
                                  options={{
                                    addRemoveLinks: true,
                                    maxFilesize: 10000, // MB
                                    maxFiles: 1,
                                    acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                    timeout: 0
                                  }}
                                  onChange={(file) => setAtr(file)}
                                  style={DZ_STYLE}
                              />
                            </MDBox>
                            <UploadedFilePreview file={atr} layout="stack" onRemove={() => setAtr([])}/>
                          </MDBox>
                        </Grid>

                        {/* Approved Mail */}
                        <Grid item xs={12} sm={6} md={1}>
                          <MDBox display="flex" flexDirection="column" alignItems="center">
                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                              Approved Mail
                            </MDTypography>
                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                              <MDDropzone
                                  options={{
                                    addRemoveLinks: true,
                                    maxFilesize: 10000, // MB
                                    maxFiles: 1,
                                    acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                    timeout: 0
                                  }}
                                  onChange={(files) => setConfirmationMail(files)}
                                  style={DZ_STYLE}
                              />
                            </MDBox>
                            <UploadedFilePreview
                                file={confirmationMail}
                                layout="stack"
                                onRemove={() => setConfirmationMail([])}
                            />
                          </MDBox>
                        </Grid>
                        {/* Packing List */}
                        <Grid item xs={12} sm={6} md={1}>
                          <MDBox display="flex" flexDirection="column" alignItems="center">
                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                              Packing List
                            </MDTypography>
                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                              <MDDropzone
                                  options={{
                                    addRemoveLinks: true,
                                    maxFilesize: 10000, // MB
                                    maxFiles: 1,
                                    acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                    timeout: 0
                                  }}
                                  onChange={(files) => setPackingList(files)}
                                  style={DZ_STYLE}
                              />
                            </MDBox>
                            <UploadedFilePreview
                                file={packingList}
                                layout="stack"
                                onRemove={() => setPackingList([])}
                            />
                          </MDBox>
                        </Grid>

                        {/* Commercial Invoice */}
                        <Grid item xs={12} sm={6} md={1}>
                          <MDBox display="flex" flexDirection="column" alignItems="center">
                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                              Commercial Invoice
                            </MDTypography>
                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                              <MDDropzone
                                  options={{
                                    addRemoveLinks: true,
                                    maxFilesize: 10000, // MB
                                    maxFiles: 1,
                                    acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                    timeout: 0
                                  }}
                                  onChange={(files) => setCommercialInvoice(files)}
                                  style={DZ_STYLE}
                              />
                            </MDBox>
                            <UploadedFilePreview
                                file={commercialInvoice}
                                layout="stack"
                                onRemove={() => setCommercialInvoice([])}
                            />
                          </MDBox>
                        </Grid>
                       {/*  Vendor/Supplier Invoice (Pickup Carrier)
                        <Grid item xs={12} sm={6} md={1}>
                          <MDBox display="flex" flexDirection="column" alignItems="center">
                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                              Vendor/Supplier Invoice (Pickup Carrier)
                            </MDTypography>
                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                              <MDDropzone
                                  options={{
                                    addRemoveLinks: true,
                                    maxFilesize: 10000, // MB
                                    maxFiles: 1,
                                    acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                    timeout: 0
                                  }}
                                  onChange={(files) => setPickupCarrier(files)}
                                  style={DZ_STYLE}
                              />
                            </MDBox>
                            <UploadedFilePreview
                                file={pickupCarrier}
                                layout="stack"
                                onRemove={() => setPickupCarrier([])}
                            />
                          </MDBox>
                        </Grid>

                         Vendor/Supplier Invoice (Carrier Custom Broker)
                        <Grid item xs={12} sm={6} md={1}>
                          <MDBox display="flex" flexDirection="column" alignItems="center">
                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                              Vendor/Supplier Invoice (Carrier Custom Broker)
                            </MDTypography>
                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                              <MDDropzone
                                  options={{
                                    addRemoveLinks: true,
                                    maxFilesize: 10000, // MB
                                    maxFiles: 1,
                                    acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                    timeout: 0
                                  }}
                                  onChange={(files) => setCarrierBroker(files)}
                                  style={DZ_STYLE}
                              />
                            </MDBox>
                            <UploadedFilePreview
                                file={carrierBroker}
                                layout="stack"
                                onRemove={() => setCarrierBroker([])}
                            />
                          </MDBox>
                        </Grid>*/}

                        {/* Koşullu Alanlar */}
                        {proofOfDelivery && (
                            <>
                              {/* Proof of Delivery */}
                              <Grid item xs={12} sm={6} md={1}>
                                <MDBox display="flex" flexDirection="column" alignItems="center">
                                  <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                    Proof of Delivery
                                  </MDTypography>
                                  <MDBox sx={DROPZONE_WRAPPER_SX}>
                                    <MDDropzone
                                        options={{
                                          addRemoveLinks: true,
                                          maxFilesize: 10000, // MB
                                          maxFiles: 1,
                                          acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                          timeout: 0
                                        }}
                                        onChange={(files) => setSignedCmr(files)}
                                        style={DZ_STYLE}
                                    />
                                  </MDBox>
                                  <UploadedFilePreview
                                      file={signedCmr}
                                      layout="stack"
                                      onRemove={() => setSignedCmr([])}
                                  />
                                </MDBox>
                              </Grid>

                              {/* Closed T1/T2 */}
                              <Grid item xs={12} sm={6} md={1}>
                                <MDBox display="flex" flexDirection="column" alignItems="center">
                                  <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                    Closed T1/T2
                                  </MDTypography>
                                  <MDBox sx={DROPZONE_WRAPPER_SX}>
                                    <MDDropzone
                                        options={{
                                          addRemoveLinks: true,
                                          maxFilesize: 10000, // MB
                                          maxFiles: 1,
                                          acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                          timeout: 0
                                        }}
                                        onChange={(files) => setClosedT1t2(files)}
                                        style={DZ_STYLE}
                                    />
                                  </MDBox>
                                  <UploadedFilePreview
                                      file={closedT1t2}
                                      layout="stack"
                                      onRemove={() => setClosedT1t2([])}
                                  />
                                </MDBox>
                              </Grid>
                            </>
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </MDBox>
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <div style={{display: "flex", gap: "10px", flexWrap: "wrap"}}>
          <Button
              variant="contained"
              onClick={(e) => submitHandler(e, "shipment")}
              disabled={loading}
              style={{backgroundColor: "#0B1F3A", color: "#FFFFFF"}}
          >
            {isEditing && !isCloneMode ? "Update Shipment" : "Create Shipment"}
          </Button>

          {isEditing && (
              <Button
                  variant="contained"
                  onClick={handleCloneShipment}
                  disabled={loading}
                  style={{backgroundColor: "#FF9800", color: "#FFFFFF"}}
              >
                Clone Shipment
              </Button>
          )}

          <Tooltip
              arrow
              title={linkedRmbl ? `This shipment is already connected to ${linkedRmblLabel}.` : ""}
          >
            {/* span: a disabled button fires no events, so the tooltip needs a wrapper */}
            <span>
              <Button
                  variant="contained"
                  onClick={handleOpenConnectRmbl}
                  disabled={loading || !isRequiredFieldsFilled() || Boolean(linkedRmbl)}
                  style={{backgroundColor: linkedRmbl ? "#94a3b8" : "#1976D2", color: "#FFFFFF"}}
              >
                Connect RMBL
              </Button>
            </span>
          </Tooltip>
        </div>
        </fieldset>
        <Dialog
            open={connectRmblOpen}
            onClose={() => setConnectRmblOpen(false)}
            maxWidth="md"
            fullWidth
        >
          <DialogTitle>Connect RMBL</DialogTitle>
        <DialogContent sx={{ p: 3, backgroundColor: "#f8fafc" }}>
          <MDBox
              display="grid"
              gridTemplateColumns={{ xs: "1fr", md: "1fr 1fr" }}
              gap={2}
              mb={3}
          >
            {/* NEW RMBL */}
            <MDBox
                sx={{
                  p: 2.5,
                  borderRadius: "10px",
                  background: "#ecfdf5",
                  border: "1px solid #bbf7d0",
                  boxShadow: "none",
                }}
            >
              <MDBox display="flex" alignItems="center" gap={1} mb={1}>
                <AddCircleIcon sx={{ color: "#16a34a", fontSize: 30 }} />

                <MDTypography
                    variant="h5"
                    fontWeight="bold"
                    sx={{ color: "#166534" }}
                >
                  Create New RMBL
                </MDTypography>
              </MDBox>

              <MDTypography
                  variant="button"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    display: "block",
                  }}
              >
                Start a brand-new RMBL document and automatically attach
                this shipment into the manifest structure.
              </MDTypography>

              <Button
                  fullWidth
                  variant="contained"
                  onClick={handleNewRmbl}
                  sx={{
                    mt: 3,
                    height: 46,
                    borderRadius: "12px",
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: "14px",
                    background:
                        "#16a34a !important",
                    boxShadow: "0 10px 24px rgba(34,197,94,0.25)",
                    "&:hover": {
                      background:
                          "#15803d !important",
                    },
                  }}
              >
                Create RMBL
              </Button>
            </MDBox>

            {/* EXISTING RMBL */}
            <MDBox
                sx={{
                  p: 2.5,
                  borderRadius: "10px",
                  background: "#eff6ff",
                  border: "1px solid #bfdbfe",
                  boxShadow: "none",
                }}
            >
              <MDBox display="flex" alignItems="center" gap={1} mb={1}>
                <Inventory2Icon sx={{ color: "#2563eb", fontSize: 30 }} />

                <MDTypography
                    variant="h5"
                    fontWeight="bold"
                    sx={{ color: "#1d4ed8" }}
                >
                  Existing RMBLs
                </MDTypography>
              </MDBox>

              <MDTypography
                  variant="button"
                  sx={{
                    color: "#4b5563",
                    lineHeight: 1.7,
                    display: "block",
                  }}
              >
                Load previously created RMBL records and connect this
                shipment into an existing manifest.
              </MDTypography>

              <Button
                  fullWidth
                  variant="contained"
                  onClick={handleLoadExistingRmbls}
                  sx={{
                    mt: 3,
                    height: 46,
                    borderRadius: "12px",
                    textTransform: "none",
                    fontWeight: 700,
                    fontSize: "14px",
                    background:
                        "#2563eb !important",
                    boxShadow: "0 10px 24px rgba(37,99,235,0.22)",
                    "&:hover": {
                      background:
                          "#1d4ed8 !important",
                    },
                  }}
              >
                Load RMBLs
              </Button>
            </MDBox>
          </MDBox>

          {/* LOADING */}
          {rmblLoading && (
              <MDBox
                  sx={{
                    p: 4,
                    borderRadius: "10px",
                    background: "#fff",
                    border: "1px solid #e5e7eb",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    gap: 1,
                  }}
              >
                <CircularProgress color="info" />

                <MDTypography variant="button" fontWeight="bold">
                  Loading RMBL records...
                </MDTypography>
              </MDBox>
          )}

          {/* RMBL LIST */}
          {!rmblLoading && existingRmbls.length > 0 && (
              <MDBox>
                <MDTypography
                    variant="h6"
                    fontWeight="bold"
                    mb={2}
                    sx={{ color: "#0f172a" }}
                >
                  Available RMBL Records
                </MDTypography>

                <MDBox
                    sx={{
                      maxHeight: 420,
                      overflowY: "auto",
                      pr: 0.5,
                    }}
                >
                  {existingRmbls.map((rmbl) => {
                    const attr = rmbl.attributes || {};

                    const shipments = attr.shipments || [];
                    const shipmentCount = shipments.length;

                    const firstShipment =
                        shipments[0]?.attributes || shipments[0] || {};

                    const pickup = [
                      firstShipment?.pickupLocation?.city,
                      firstShipment?.pickupLocation?.country,
                    ]
                        .filter(Boolean)
                        .join(", ");

                    const delivery = [
                      firstShipment?.deliveryLocation?.city,
                      firstShipment?.deliveryLocation?.country,
                    ]
                        .filter(Boolean)
                        .join(", ");

                    return (
                        <MDBox
                            key={rmbl.id}
                            sx={{
                              p: 2,
                              mb: 2,
                              borderRadius: "10px",
                              background: "#ffffff",
                              border: "1px solid #e5e7eb",
                              boxShadow:
                                  "none",
                              transition: "all .2s ease",
                              "&:hover": {
                                transform: "translateY(-2px)",
                                borderColor: "#2563eb",
                                boxShadow:
                                    "none",
                              },
                            }}
                        >
                          <MDBox
                              display="flex"
                              justifyContent="space-between"
                              alignItems="flex-start"
                              gap={2}
                              flexWrap="wrap"
                          >
                            <MDBox flex={1}>
                              <MDBox
                                  display="flex"
                                  alignItems="center"
                                  gap={1}
                                  mb={1}
                                  flexWrap="wrap"
                              >
                                <MDTypography
                                    variant="h6"
                                    fontWeight="bold"
                                    sx={{ color: "#0f172a" }}
                                >
                                  {attr.rmblNumber ||
                                      "Unnamed RMBL"}
                                </MDTypography>

                                <MDBox
                                    sx={{
                                      px: 1.2,
                                      py: 0.4,
                                      borderRadius: "999px",
                                      background:
                                          "rgba(37,99,235,0.08)",
                                      border:
                                          "1px solid rgba(37,99,235,0.18)",
                                    }}
                                >
                                  <MDTypography
                                      variant="caption"
                                      fontWeight="bold"
                                      sx={{ color: "#2563eb" }}
                                  >
                                    {shipmentCount} Shipment
                                    {shipmentCount > 1
                                        ? "s"
                                        : ""}
                                  </MDTypography>
                                </MDBox>
                              </MDBox>

                              <MDBox
                                  display="grid"
                                  gridTemplateColumns={{
                                    xs: "1fr",
                                    sm: "1fr 1fr 1fr",
                                  }}
                                  gap={1}
                              >
                                <MDBox
                                    sx={{
                                      p: 1.2,
                                      borderRadius: "12px",
                                      backgroundColor: "#f8fafc",
                                      border:
                                          "1px solid #e2e8f0",
                                    }}
                                >
                                  <MDTypography
                                      variant="caption"
                                      fontWeight="bold"
                                      sx={{ color: "#64748b" }}
                                  >
                                    Pickup
                                  </MDTypography>

                                  <MDTypography
                                      variant="button"
                                      display="block"
                                      fontWeight="medium"
                                  >
                                    {pickup || "-"}
                                  </MDTypography>
                                </MDBox>

                                <MDBox
                                    sx={{
                                      p: 1.2,
                                      borderRadius: "12px",
                                      backgroundColor: "#f8fafc",
                                      border:
                                          "1px solid #e2e8f0",
                                    }}
                                >
                                  <MDTypography
                                      variant="caption"
                                      fontWeight="bold"
                                      sx={{ color: "#64748b" }}
                                  >
                                    Delivery
                                  </MDTypography>

                                  <MDTypography
                                      variant="button"
                                      display="block"
                                      fontWeight="medium"
                                  >
                                    {delivery || "-"}
                                  </MDTypography>
                                </MDBox>

                                <MDBox
                                    sx={{
                                      p: 1.2,
                                      borderRadius: "12px",
                                      backgroundColor: "#f8fafc",
                                      border:
                                          "1px solid #e2e8f0",
                                    }}
                                >
                                  <MDTypography
                                      variant="caption"
                                      fontWeight="bold"
                                      sx={{ color: "#64748b" }}
                                  >
                                    Created
                                  </MDTypography>

                                  <MDTypography
                                      variant="button"
                                      display="block"
                                      fontWeight="medium"
                                  >
                                    {attr.createdAt
                                        ? new Date(
                                            attr.createdAt
                                        ).toLocaleDateString()
                                        : "-"}
                                  </MDTypography>
                                </MDBox>
                              </MDBox>
                            </MDBox>

                            <Button
                                variant="contained"
                                onClick={() =>
                                    handleSelectExistingRmbl(
                                        rmbl.id
                                    )
                                }
                                sx={{
                                  minWidth: 110,
                                  height: 38,
                                  borderRadius: "10px",
                                  backgroundColor: "#0f172a !important",
                                  color: "#ffffff !important",
                                  fontWeight: 700,
                                  boxShadow: "0 6px 16px rgba(15,23,42,0.18)",
                                  "&:hover": {
                                    backgroundColor: "#1e293b !important",
                                  },
                                }}
                            >
                              Connect
                            </Button>
                          </MDBox>
                        </MDBox>
                    );
                  })}
                </MDBox>
              </MDBox>
          )}

          {/* EMPTY */}
          {!rmblLoading && existingRmbls.length === 0 && (
              <MDBox
                  sx={{
                    p: 4,
                    borderRadius: "10px",
                    textAlign: "center",
                    background: "#fff",
                    border: "1px dashed #cbd5e1",
                  }}
              >
                <Inventory2Icon
                    sx={{
                      fontSize: 48,
                      color: "#94a3b8",
                      mb: 1,
                    }}
                />

                <MDTypography variant="h6" fontWeight="bold">
                  No RMBL Records
                </MDTypography>

                <MDTypography variant="button" color="text">
                  Click “Load RMBLs” to fetch available records.
                </MDTypography>
              </MDBox>
          )}
        </DialogContent>
          <DialogActions>
            <Button onClick={() => setConnectRmblOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog
            open={customerModalOpen}
            onClose={() => setCustomerModalOpen(false)}
            maxWidth="xl"
            fullWidth
        >
          <DialogTitle>
            Create Customer
            <IconButton
                onClick={() => setCustomerModalOpen(false)}
                sx={{ position: "absolute", right: 12, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            <CreateCustomer
                isModal
                onClose={() => setCustomerModalOpen(false)}
                onCreated={handleCustomerCreatedFromModal}
            />
          </DialogContent>
        </Dialog>

        <Dialog
            open={serviceProviderModalOpen}
            onClose={() => setServiceProviderModalOpen(false)}
            maxWidth="xl"
            fullWidth
        >
          <DialogTitle>
            Create Service Provider
            <IconButton
                onClick={() => setServiceProviderModalOpen(false)}
                sx={{ position: "absolute", right: 12, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent dividers>
            <CreateServiceProvider
                isModal
                onClose={() => setServiceProviderModalOpen(false)}
                onCreated={handleServiceProviderCreatedFromModal}
            />
          </DialogContent>
        </Dialog>
        <br/><br/>
        <Footer/>
      </DashboardLayout>
  );
};

export default CreateShipment;
